import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Checkbox,
  CardHeader, 
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFormik } from "formik";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useGetAllSearchCompanyQuery,
  useGetAllWorkOrderHistoryQuery,
  useGetAllAssignDriverHistoryQuery,
  useGetAllInvoiceHistoryQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetLastWorkOrderIdQuery,
  useGetProductQuery,
  useGetTaxQuery,
  useGetWorkOrderQuery,
  useUpdateInvoiceStatusQuery,
  useGetEmailTemplateQuery,
  useGetAllInvoiceQuery,
  useGetDriverQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate, Link } from "react-router-dom";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import {
  ICompanyDetails,
  ICustomer,
  IProductPopUP,
  ITaxes,
  IEmailTemplate,
  IDriver,
  IAssignDrivers,
} from "../../../Api/Interface/api.interface";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../../Components/Validation/validationUtils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toDate } from "date-fns";
import dayjs, { Dayjs } from "dayjs";
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import {
  ProductType,
  TransferType,
  WorkOrderStatus,
} from "../../../Core/Enum/enum";
import AddIcon from "@mui/icons-material/Add";
import { FaTrash } from "react-icons/fa";
import { FaUndo } from 'react-icons/fa'	
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import NewCompanyPopUp from "../../CompanyInfo/Components/NewCompanyPopUp";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { useParams } from "react-router-dom";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import placeholderImage from '../../../Images/fav.png';
import ReactQuill from 'react-quill';
import axios from "axios";
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import { AssignmentOutlined } from "@mui/icons-material";
import Avatar from "@mui/material/Avatar";
import { alpha } from "@mui/material/styles";
// import ViewWorkOrder from "../Components/ViewWorkOrder";
import ViewWorkOrder from "../../CustomerTransaction/Components/ViewWorkOrder";
import ViewInvoice from "../../CustomerTransaction/Components/ViewInvoice";
import DescriptionIcon from '@mui/icons-material/Description';
import ReplayIcon from '@mui/icons-material/Replay';
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import { AuthContext } from "../../Login/AuthContext";

    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);

const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
    case WorkOrderStatus.Initiated:
    return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

const getTransferType = (statusCode: string): string => {
  switch (statusCode) {
    case TransferType.OneWayTransfer:
      return "One Way Transfer";
    case TransferType.RoundTrip:
      return "Round Trip";
    // case TransferType.MultiDestination:
    //   return "Multi Destination";
    default:
      return "Unknown Status";
  }
};

const steps = ["Quote", "Invoice", "Payment", "Assign Driver", "Deliver"];

const stepDetails = [
  { title: "Quote", createdBy: "John Doe", createdAt: "2024-01-30 10:00 AM" },
  { title: "Invoice", convertedBy: "Jane Smith", convertedAt: "2024-01-30 11:30 AM" },
  { title: "Payment", processedBy: "Alice Johnson", processedAt: "2024-01-30 01:00 PM" },
  { title: "Assign Driver", assignedBy: "Bob Brown", assignedAt: "2024-01-30 02:15 PM" },
  { title: "Deliver", deliveredBy: "Chris White", deliveredAt: "2024-01-30 03:45 PM" },
];


const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      // backgroundColor: theme.palette.success.main,
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 7,
    border: 0,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 1,
  },
}));

const CustomStepLabel = styled(StepLabel)(() => ({
  "& .MuiStepLabel-iconContainer": {
    borderRadius: "50%",
    border: "2px solid",
    width: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: "bold",
  },
}));




interface IProduct {
  productName: string;
  productDescription: string;
  productImg: String | null;
  numberOfPassengers: number | null;
  busCount: number | null;
  transferType: string;
  transferTypeFrom: string;
  transferTypeTo: string;
  transferTypeDescription: string;
  departureDateTime: Dayjs | null;
  returnDateTime: Dayjs | null;
  departureAddress: string;
  destinationAddress: string;
  multiDestination: string;
  quantity: number | null;
  price: number | null;
  tax: number | null;
  taxAmount: number | null;
  total: number;
  taxId: number | null;
  unitPriceWithDiscount: number | null;
  unitTotalWithDiscount: number;
  productType: string;
  productLongDescription: string;
  productShortDescription: string;
  pickups?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  dropoffs?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  returnPickups?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  returnDropoffs?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  useSameAsOutbound?: boolean;
}

interface IDiscount {
  value: number | null;
  description: string;
}

interface IQuoteWorkOrder {
  id: number;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: Dayjs;
  quoteWorkOrderDueDate: Dayjs;
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: IProduct[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: IDiscount[];
  customer: ICustomer;
  company: ICompanyDetails;
  assign_driver: IAssignDrivers;
  quoteWorkOrderCustomerRemark: string;
  quoteWorkOrderCustomerMemo: string;
  quoteWorkOrderSaleDiscount: string;
  quoteWorkOrderSaleSubTotal: string;
  quoteWorkOrderCustomerProjectId: string;
  created_by: number;
  created_at: string;
  mainStatus: number;
  invoiceId: number;
  payment_id: string;
  updated_by: string;
}
interface IInvoice {
  id: number;
  work_order_id: string;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: Dayjs;
  quoteWorkOrderDueDate: Dayjs;
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: IProduct[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: IDiscount[];
  customer: ICustomer;
  company: ICompanyDetails;
  quoteWorkOrderCustomerRemark: string;
  quoteWorkOrderCustomerMemo: string;
  quoteWorkOrderSaleDiscount: string;
  quoteWorkOrderSaleSubTotal: string;
  created_by: number;
  created_at: string;
  mainStatus: number;
  invoiceId: number;
  payment_id: string;
  amount_paid: number;
  due_amount: number;
  po_number: string;
}

interface EmailLogs {
  id: number;
  to: string;
  workOrderNo: string;
  created_at: string;
  subject: string;
  message: string;
  amount: number;
}

interface BamboraTransaction {
  label: string;
  trnId: string;
  trnAmount: number;
  created_at: string;
  trnDate: string;
  trnTime: string;
  messageText: string;
  trnCardType: String;
  trnApproved: String;
}

interface DeclinedTransaction {
  label: string;
  trnId: string;
  trnAmount: number;
  created_at: string;
  trnDate: string;
  trnTime: string;
}

interface  Payment {
  id: number;
  transaction_id: string;
  amount: number;
  payment_date: string;
  payment_method: string;
  payment_mode: string;
  description: string;
  file_path?: string;
  created_at: string;
  updated_at: string;
  date: string;
  is_return: number;
  is_deleted: number;
}

  interface UserInfo {
    id: number;
    username: string;
    token: string;
    user_id: number;
  }


const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const { id: QuoteId } = useParams<{ id: string }>();
  useEffect(() => {}, [QuoteId]);


  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [activeStep, setActiveStep] = useState(0);
  const [mainStatus, setMainStatus] = useState("");
  const [id, setId] = useState("");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [invoiceTotalPrice, setInvoiceTotalPrice] = useState(0);
  const [invoiceTotalTax, setInvoiceTotalTax] = useState(0);
  const [invoiceEmailData, setInvoiceEmailData] = useState({ to: "", template:"", subject: "", message: ""  });
  const [driverEmailData, setDriverEmailData] = useState({ to: "", template:"", subject: "", message: ""  });
  

  const [expandedSteps, setExpandedSteps] = useState<number[]>([]);
  const [expandedStep, setExpandedStep] = useState<number[]>([]);
  const [expandedStepsInvoice, setExpandedStepsInvoice] = useState<number[]>([]);
  const [showAllDrivers, setShowAllDrivers] = useState(false);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [showEmailLog, setShowEmailLog] = useState(false);
  const [amount, setAmount] = useState(0.00);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [showDriverDialog, setShowDriverDialog] = useState(false);
  const [showDriverEmailDialog, setShowDriverEmailDialog] = useState(false);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [currentSearchQueryEmailTemplate, setCurrentSearchQueryEmailTemplate] =
  useState("");
  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState<{ [key: string]: boolean }>({});
  const { showErrorMessage, showMessage } = useNotifier();
  const API_URL = process.env.REACT_APP_API_URL;
  // const PAYMENT_URL = process.env.REACT_APP_PAYMENT_URL;
  
  const [emailLog, setEmailLog] = useState<EmailLogs[]>([]); 
  const [bamboraTransactionData, setBamboraTransactionData] = useState<BamboraTransaction[]>([]); 
  const [declinedTransaData, setDeclinedTransaData] = useState<DeclinedTransaction[]>([]); 
  const [currentSearchQueryInvoice, setCurrentSearchQueryInvoice] =
  useState("");
  const [currentSearchQueryDriver, setCurrentSearchQueryDriver] =
  useState("");
  const [amountPaid, setAmountPaid] = useState(0.00);
  const [dueAmount, setDueAmount] = useState(0.00);
//  const [selectedDrivers, setSelectedDrivers] = useState<number[]>([]);
  const [selectedDrivers, setSelectedDrivers] = useState<{ 
    id: number; 
    price: number; 
    hourPrice: number 
  }[]>([]);
  
  const [openModal, setOpenModal] = useState(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const isPdf = fileUrl?.endsWith('.pdf');
  const [shouldIncrementStep, setShouldIncrementStep] = useState(true);
  const [tripPrice, setTripPrice] = useState('');
  const [hourPrice, setHourPrice] = useState('');
  const [isPriceDialogOpen, setIsPriceDialogOpen] = useState(false);
  const [isPoNumberDialogOpen, setIsPoNumberDialogOpen] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState<number | null>(null);
  const [selectedDriverName, setSelectedDriverName] = useState<string | null>(null);
  const [poNumber, setPoNumber] = useState("");
  const [openViewQuote, setOpenViewQuote] = useState(false);
  const [openViewInvoice, setOpenViewInvoice] = useState(false);
  const [invoiceId, setInvoiceId] = useState("");
  const [workOrderId, setWorkOrderId] = useState("");
  const [editableAmount, setEditableAmount] = useState("");
  const [paymentUrl, setPaymentUrl] = useState("");
  const [isRefundLoading, setIsRefundLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);


  const getCurrentDateCanada = () => {
 return new Date().toLocaleDateString("en-CA", {timeZone: 'America/Toronto'})
};

const [paymentData, setPaymentData] = useState({ paymentDate:getCurrentDateCanada(), amount: "", paymentMethod:"", file: null as File | null, description: ""  });
const [showPaymentMethodError, setShowPaymentMethodError] = useState(false);

  const {
    data: workOrderData,
    isLoading: workIsLoading,
    isError: workOrderError,
    refetch: workOrderRefetch,
  } = useGetWorkOrderQuery({
    searchText: "",
    id: String(QuoteId),
  });

  // const {
  //   data: updateData,
  //   isLoading: updateIsLoading,
  //   isError: updateError,
  // } = useUpdateInvoiceStatusQuery({
  //   mainStatus: mainStatus,
  //   id: id,
  //   po_number: poNumber || "",
  // });

  const {
    data: updateData,
    isLoading: updateIsLoading,
    isError: updateError,
} = useUpdateInvoiceStatusQuery({
    mainStatus: "2",
    id: id, 
    po_number: poNumber || "", //  Ensure po_number is always provided
}, { skip: !id });


  const {
    data: workOrderHistoryData,
    isLoading: workOrderHistoryIsLoading,
    isError: workOrderHistoryError,
    refetch: workOrderHistoryRefetch,
  } = useGetAllWorkOrderHistoryQuery({
    id: String(QuoteId),
  });

  const {
    data: assignDriverHistoryData,
    isLoading: assignDriverHistoryIsLoading,
    isError: assignDriverHistoryError,
    refetch: assignDriverHistoryRefetch,
  } = useGetAllAssignDriverHistoryQuery({
    id: String(QuoteId),
  });
  


  const {
    data: invoiceHistoryData,
    isLoading: invoiceHistoryIsLoading,
    isError: invoiceHistoryError,
    refetch: invoiceHistoryRefetch,
  } = useGetAllInvoiceHistoryQuery({
    id: String(QuoteId),
  });

  const {
      data: invoiceData,
      isLoading: invoiceIsLoading,
      isError: invoiceError,
      refetch: invoiceRefetch,
    } = useGetAllInvoiceQuery({
      searchText: currentSearchQueryInvoice,
      id: "",
      quoteWorkOrderCustomerId: "",
      quoteWorkOrderCustomerProjectId: "",
    });

    const {
      data: driverData,
      isLoading: driverIsLoading,
      isError: driverError,
      refetch: driverRefetch,
    } = useGetDriverQuery({
      searchText: currentSearchQueryDriver,
      id: "",
    });

  const WorkOrderDataList = useMemo(() => {
    if (
      workOrderData &&
      Array.isArray(workOrderData.data) &&
      workOrderData.data.length > 0
    ) {
      return workOrderData.data[0] as IQuoteWorkOrder;
    }
    return null;
  }, [workOrderData]);

  const [payments, setPayments] = useState<Payment[]>([]);
  const [refunds, setRefunds] = useState<Payment[]>([]);

  


  const invoiceList = useMemo(() => {
    if (
      invoiceData &&
      Array.isArray(invoiceData.data) &&
      invoiceData.data.length > 0
    ) {
      // Find and return the first matching invoice
      const matchingInvoice = invoiceData.data.find(
        (invoice: IInvoice) => String(invoice.work_order_id) === String(QuoteId)
      );

      return matchingInvoice || null; // Return null if no match is found
    }
    return null; // Return null if invoiceData is not valid
  }, [invoiceData, QuoteId]);


 

  // const invoiceList: IInvoice[] = useMemo(() => {
  //     if (invoiceData && Array.isArray(invoiceData.data)) {
  //       return invoiceData.data as IInvoice[];
  //     }
  //     return [];
  //   }, [invoiceData]);

    const driverList: IDriver[] = useMemo(() => {
      if (driverData && Array.isArray(driverData.data)) {
        return driverData.data as IDriver[];
      }
      return [];
    }, [driverData]);

    const isDriverAvailable = (driverAvailability: any, departureDateTime: any) => {
      const driverStartTime = moment(driverAvailability.startTime, 'HH:mm'); // Driver's start time
      const driverEndTime = moment(driverAvailability.endTime, 'HH:mm'); // Driver's end time
    
      const departureTime = moment(departureDateTime, 'DD-MMM-YY hh:mm A'); // Departure time


      // Check if the departure time is within the driver's availability window
      return departureTime.isBetween(driverStartTime, driverEndTime, null, '[]'); // '[]' includes the boundary times
    };
    

React.useEffect(() => {
    const fetchUserInfo = async () => {
      try {
          const response = await axios.post(
              `${API_URL}/user/userInfo`,
              {}, // No body required
              {
                  headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
                  },
              }
          );
          setUserInfo(response.data.data); // Update your state with the response
    
      } catch (error) {
          console.error('Error fetching user info', error);
      }
  };
    
    fetchUserInfo();
  }, []);

    const checkDriverAvailability = (
      driverAvailability: any,
      departureDateTime: string,
      returnDateTime: string
    ) => {
      const departureTime = dayjs(departureDateTime); // Product's departure time
      const returnTime = dayjs(returnDateTime); // Product's return time
    
      const transferDay = departureTime.format('dddd'); // Day of the transfer (e.g., 'Thursday')
    
      // Find availability for the day
      const dayAvailability = driverAvailability.find((day: any) => day.day === transferDay);
    
      if (!dayAvailability || dayAvailability.timeSlots.length === 0) {
        console.log(`Driver not available on ${transferDay}`);
        return false;
      }
    
      // Ensure times are compared only as "HH:mm"
      const departureTimeOnly = departureTime.format('HH:mm');
      const returnTimeOnly = returnTime.format('HH:mm');
    
      // Check if the transfer time fits within any available time slot
      const isAvailable = dayAvailability.timeSlots.some((slot: any) => {
        if (slot.startTime && slot.endTime) {
          // console.log('Checking slot:', slot); 
          const slotStart = dayjs(`1970-01-01T${slot.startTime}:00`);
          const slotEnd = dayjs(`1970-01-01T${slot.endTime}:00`);
          const departure = dayjs(`1970-01-01T${departureTimeOnly}:00`);
          const returnT = dayjs(`1970-01-01T${returnTimeOnly}:00`);
    
          // Validate if times are valid
          if (!slotStart.isValid() || !slotEnd.isValid() || !departure.isValid() || !returnT.isValid()) {
            console.error('Invalid time detected:', {
              slotStart: slot.startTime,
              slotEnd: slot.endTime,
              departure: departureTimeOnly,
              returnT: returnTimeOnly,
            });
            return false;
          }
    
        
          // Check if both departure and return fit within the time slot
          // const fitsWithinSlot =
          //   departure.isSameOrAfter(slotStart) && returnT.isSameOrBefore(slotEnd);
            const fitsWithinSlot = departure.isSameOrAfter(slotStart) && departure.isBefore(slotEnd);

          // console.log(
          //   `Checking slot: ${slot.startTime} - ${slot.endTime} | Departure: ${departure.format(
          //     'HH:mm'
          //   )} | Return: ${returnT.format('HH:mm')} | Fits: ${fitsWithinSlot}`
          // );
    
          return fitsWithinSlot;
        }
        return false;
      });
    
      return isAvailable;
    };
    
    
    const availableDrivers = driverList.filter((driver) =>
      driver.driverUserRole === 'driver' &&  // Only filter drivers with 'DRIVER' role
      invoiceList?.quoteWorkOrderSale.some((product: any) => {
        //  console.log('Driver:', driver);
        //  console.log('Product:', product);
    
        const isAvailable = checkDriverAvailability(
          driver.availability,
          product.departureDateTime,
          product.returnDateTime
        );
    
        // console.log(
        //   `Driver ${driver.driverFirstName} ${driver.driverLastName} available: ${isAvailable}`
        // );
        return isAvailable;
      })
    );

    const nonAvailableDrivers = driverList.filter((driver) =>
      driver.driverUserRole === 'driver' && // Only filter drivers with 'DRIVER' role
      invoiceList?.quoteWorkOrderSale.every((product: any) => {
        const isAvailable = checkDriverAvailability(
          driver.availability,
          product.departureDateTime,
          product.returnDateTime
        );
        return !isAvailable; // Non-available drivers will have no matching availability
      })
    );
    
   // console.log('Available Drivers:', availableDrivers);
    
    


    const invoiceHistories = useMemo(() => {
      if (
        invoiceHistoryData &&
        Array.isArray(invoiceHistoryData.data) &&
        invoiceHistoryData.data.length > 0
      ) {
        return invoiceHistoryData.data; // Return the full array
      }
      return [];
    }, [invoiceHistoryData]);
    

   const {
      data: emailTemplateData,
      isLoading: emailTemplateIsLoading,
      isError: emailTemplateError,
      refetch: emailTemplateRefetch,
    } = useGetEmailTemplateQuery({
      searchText: currentSearchQueryEmailTemplate,
      // id: "",
    });

  const emailTemplateList: IEmailTemplate[] = useMemo(() => {
      if (emailTemplateData && Array.isArray(emailTemplateData.data)) {
        return emailTemplateData.data as IEmailTemplate[];
      }
      return [];
    }, [emailTemplateData]);


    useEffect(() => {
      fetchPayments();
    }, [QuoteId]); // Runs when QuoteId changes
    


    const fetchPayments = () => {
      if (!QuoteId) return;
    
      axios.get(`${API_URL}/payments-by-workorder?work_order_id=${QuoteId}`)
        .then(response => {
          const sortedPayments = response.data.sort((a: Payment, b: Payment) => {
            return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
          });

        const validPayments = sortedPayments.filter((payment: Payment) => payment.is_deleted === 0 && payment.is_return === 0);

    
          setPayments(validPayments);

      const refunded = sortedPayments.filter((payment: Payment) => payment.is_return === 1);
      setRefunds(refunded);

          setLoading(false);
        })
        .catch(error => {
          console.error("Error fetching payments:", error);
          setLoading(false);
        });
    };
    
    
    useEffect(() => {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };
      axios.get(`${API_URL}/payment-url`, {headers})
        .then(response => {
          setPaymentUrl(response.data.payment_url);
        })
        .catch(error => {
          console.error("Error fetching payment URL:", error);
        });
    }, []);



  useEffect(() => {


   // console.log('quoteId', QuoteId, WorkOrderDataList, invoiceList);
 

    const paidAmount = invoiceList?.amount_paid || 0.00; // Default to 0 if amount_paid is not available
    const dueAmount = invoiceList?.due_amount || 0.00;
    setDueAmount(dueAmount);
    setAmountPaid(paidAmount);

    if (WorkOrderDataList?.quoteWorkOrderSaleGrandTotal) {
      const initialAmount = parseFloat((parseFloat(WorkOrderDataList.quoteWorkOrderSaleGrandTotal)).toFixed(2)); // Ensure it's a number
      
      if(paidAmount <= 0)
      {
        setAmount(initialAmount);
      }
      else{
        setAmount(dueAmount);  
      }
     
    }


    if (WorkOrderDataList && WorkOrderDataList?.customer?.customerEmail) {
      setInvoiceEmailData({ ...invoiceEmailData, to: WorkOrderDataList?.customer.customerEmail });
      // setDriverEmailData({ ...driverEmailData, to: invoiceList?.driver.driverEmail });  
    }

  }, [WorkOrderDataList, invoiceList]);


  useEffect(() => {
    const initialAmount =
      amountPaid <= 0
        ? parseFloat(invoiceList?.quoteWorkOrderSaleGrandTotal ?? "0").toFixed(2)
        : (parseFloat(invoiceList?.quoteWorkOrderSaleGrandTotal ?? "0") - (amountPaid ?? 0)).toFixed(2);
  
    setEditableAmount(initialAmount);

      setPaymentData(prev => ({
    ...prev,
    amount: initialAmount
  }));
  }, [invoiceList, amountPaid]);
  

  

 useEffect(() => {
  // Check if there is already a selected template
  if (!invoiceEmailData.template && emailTemplateList.length > 0) {
    // Find the default template with the name "Payment Link"
    const defaultTemplate = emailTemplateList.find(
      (template) => template.template_name === "Payment Link"
    );

    if (defaultTemplate) {
      // Set the default template
      setInvoiceEmailData({
        ...invoiceEmailData,
        template: String(defaultTemplate.id), // Set default template ID
        subject: defaultTemplate.subject, // Set subject
        message: defaultTemplate.message, // Set message
      });
    }
  }

  // Update the subject and message when the selected template changes
  if (invoiceEmailData.template) {
    const selectedTemplate = emailTemplateList.find(
      (template) => template.id === Number(invoiceEmailData.template)
    );

    if (selectedTemplate) {
      setInvoiceEmailData({
        ...invoiceEmailData,
        subject: selectedTemplate.subject,
        message: selectedTemplate.message,
      });
    }
  }
}, [invoiceEmailData.template, emailTemplateList]);


useEffect(() => {
  // Check if there is already a selected template
  if (!driverEmailData.template && emailTemplateList.length > 0) {
    // Find the default template with the name "Payment Link"
    const defaultTemplate = emailTemplateList.find(
      (template) => template.template_name === "Trip Assignment"
    );

    if (defaultTemplate) {
      // Set the default template
      setDriverEmailData({
        ...driverEmailData,
        template: String(defaultTemplate.id), // Set default template ID
        subject: defaultTemplate.subject, // Set subject
        message: defaultTemplate.message, // Set message
      });
    }
  }


  if (driverEmailData.template) {
    const selectedTemplate = emailTemplateList.find(
      (template) => template.id === Number(driverEmailData.template)
    );

    if (selectedTemplate) {
      setDriverEmailData({
        ...driverEmailData,
        subject: selectedTemplate.subject,
        message: selectedTemplate.message,
      });
    }
  }
}, [driverEmailData.template, emailTemplateList]);

   
      
      const fetchEmailLogs = async () => {
        try {
          const response = await axios.get(`${API_URL}/view-email-logs`);
          setEmailLog(response.data.emailLogs); // Set the fetched data to state
        } catch (error) {
          console.error("Failed to load email logs", error);
        }
      };

      const fetchBamboraTransaction = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/view-bambora-transactions`,
            {
              params: { id: QuoteId },  // Pass workOrderId as a query parameter
            }
          );
          setBamboraTransactionData(response.data.bamboraTransactions); // Set fetched data to state
        } catch (error) {
          console.error("Failed to load Bambora transactions", error);
        }
      };
    
      // Fetch declined transactions for the work order
      const fetchDeclinedTransaction = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/view-declined-transactions`,
            {
              params: { id: QuoteId }, // Pass workOrderId as a query parameter
            }
          );
          setDeclinedTransaData(response.data.declinedTransactions); // Set fetched data to state
        } catch (error) {
          console.error("Failed to load declined transactions", error);
        }
      };


      useEffect(() => {
        fetchEmailLogs();
      }, []);

      useEffect(() => {
        if (QuoteId) {
          fetchBamboraTransaction();
          fetchDeclinedTransaction();
        }
      }, [QuoteId])


 const refundPayment = async (transactionId: any) => {
              const confirmed = window.confirm("Are you sure you want to refund this payment?");
              if (!confirmed || !transactionId) return;
              setIsRefundLoading(true);

              const payload = {
                  id: transactionId,
                  updated_by: userInfo?.user_id
              };
                
              try {
              const response = await axios.post(`${paymentUrl}/api/returntransaction`, payload);
         
                  if (response.status === 200) {
                      showMessage("Refund successful!");
                       setTimeout(() => {
                          invoiceRefetch();
                         }, 1000); 
                        fetchPayments();
                  } else {
                      showErrorMessage("Refund failed");
                  }
               
              } catch (error) {
                console.error(error);
                console.log('An error occurred during refund.',error);
            } finally {
                setIsRefundLoading(false);
            }
            }


const deletePayment = (id: any) => {
      const confirmed = window.confirm("Are you sure you want to delete this payment?");
        const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };
      if (confirmed) {
        axios.post(`${API_URL}/delete-payment/${id}`, {
          work_order_id: QuoteId,
         // updated_by: userContext.userDetails.id,
          _method: 'DELETE' // Laravel will interpret this as a DELETE request
        }, {headers})
        .then(res => {
          showMessage("Payment deleted!");
       setTimeout(() => {
        invoiceRefetch(); 
             
      }, 1000); 
          fetchPayments();
        })
        .catch(error => {
          console.error("Delete error:", error);
          showErrorMessage("Failed to delete payment.");
        });
      }
    };



  const timeLineSteps = React.useMemo(() => {
    if (
      workOrderHistoryData &&
      Array.isArray(workOrderHistoryData.data) &&
      workOrderHistoryData.data.length > 0
    ) {
      const steps = workOrderHistoryData.data.map((order, index) => {
        const label =
          index === 0
            ? "Quote created"
            : order.isInvoice
            ? "Quote converted to invoice"
            : "Quote edited";
            

        const description = (
          <div>
            {index === 0 && (
              <div>
                <Typography variant="body1">
                  <strong>Created by :</strong> {order.updated_by}
                </Typography>
                <Typography variant="body1">
                  <strong>Created at :</strong>{" "}
                  {order?.created_at
                    ? dayjs(order.created_at).format("MMM D, YYYY [at] h:mm A")
                    : ""}
                </Typography>
              </div>
            )}

            {order.isInvoice == true && (
              <div>
                <Typography variant="body1">
                  <strong>Invoice Number :</strong> {order.InvoiceNo}
                </Typography>
                <Typography variant="body1">
                  <strong>Converted by :</strong> {order.updated_by}
                </Typography>
                <Typography variant="body1">
                  <strong>Converted at :</strong>{" "}
                  {order?.created_at
                    ? dayjs(order.created_at).format("MMM D, YYYY [at] h:mm A")
                    : ""}
                </Typography>
                <Grid item textAlign={"end"} justifyContent={"flex-end"}>
                  <Button
                    variant="contained"
                    startIcon={<VisibilitySharpIcon />}
                    className={classes.addButton}
                    onClick={() =>
                      navigate(
                        `/invoice/history/${WorkOrderDataList?.invoiceId}`
                      )
                    }
                  >
                    Invoice
                  </Button>
                </Grid>
              </div>
            )}
            {order.isInvoice == false && index != 0 && (
              <div>
                <Typography variant="body1">
                  <strong>Edited by :</strong> {order.updated_by}
                </Typography>
                <Typography variant="body1">
                  <strong>Edited at :</strong>{" "}
                  {order?.updated_at
                    ? dayjs(order.updated_at).format("MMM D, YYYY [at] h:mm A")
                    : ""}
                </Typography>
              </div>
            )}
            <Typography variant="body1"> </Typography>
            <TableContainer sx={{ marginTop: 2 }}>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheader}>
                      <strong>Product</strong>
                    </TableCell>
                    {/* <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Quantity</strong>
                    </TableCell> */}
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Price</strong>
                    </TableCell>
                    {/* <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Tax</strong>
                    </TableCell> */}
                    {/* <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Price After Discount</strong>
                    </TableCell> */}
                    {/* <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Total</strong>
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {workOrderError || order.quoteWorkOrderSale.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        {workOrderError
                          ? "Error fetching data"
                          // : "No data available"
                          :""
                          }
                      </TableCell>
                    </TableRow>
                  ) : (
                    order.quoteWorkOrderSale.map(
                      (
                        row: IProduct,
                        index: number 
                      ) => (
                        <TableRow key={index} className={classes.tableRowHover}>
                          <TableCell scope="row" className={classes.tablCell}>
                            {row.productName}
                          </TableCell>
                          {/* <TableCell className={classes.tablCell} align="right">
                            {row.quantity}
                          </TableCell> */}
                          <TableCell className={classes.tablCell} align="right">
                            {row.price !== null && row.price !== undefined
                              ? row.price.toFixed(2)
                              : "0.00"}
                          </TableCell>
                          {/* <TableCell className={classes.tablCell} align="right">
                           
                            {row.taxAmount}
                          </TableCell> */}
                          {/* <TableCell className={classes.tablCell} align="right">
                            {(row.unitPriceWithDiscount ?? 0).toFixed(2)}
                          </TableCell> */}
                          {/* <TableCell className={classes.tablCell} align="right">
                            {row.unitTotalWithDiscount != null
                              ? row.unitTotalWithDiscount.toFixed(2)
                              : "0.00"}
                          </TableCell> */}
                        </TableRow>
                      )
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Grid container>
              {workOrderError ||
              order.quoteWorkOrderSaleDiscountDescription.length === 0 ? (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  {workOrderError ? "Error fetching data" 
    
                    // : "No data available"
                          :""
                  }
                </Grid>
              ) : (
                order.quoteWorkOrderSaleDiscountDescription.map(
                  (discount: IDiscount, index: number) => (
                    <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                      <Grid
                        container
                        spacing={2}
                        display={"end"}
                        justifyContent={"flex-end"}
                      >
                        <Grid
                          item
                          lg={2}
                          md={2}
                          sm={4}
                          xs={8}
                          textAlign={"end"}
                        >
                          <Typography>
                            {discount.description || "Discount"}
                            {" :"}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          lg={2}
                          md={2}
                          sm={2}
                          xs={4}
                          textAlign={"end"}
                        >
                          <Typography>
                            {"$"}
                            {(discount.value ?? 0).toFixed(2)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )
                )
              )}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid
                  container
                  spacing={2}
                  display={"end"}
                  justifyContent={"flex-end"}
                >
                  <Grid
                    item
                    lg={2}
                    md={2}
                    sm={4}
                    xs={8}
                    textAlign={"end"}
                    className={classes.tablCell}
                  >
                    <Typography>Total Discount :</Typography>
                  </Grid>
                  <Grid
                    item
                    lg={2}
                    md={2}
                    sm={2}
                    xs={4}
                    textAlign={"end"}
                    className={classes.tablCell}
                  >
                    <Typography>
                      {"$"}
                      {Number(order.quoteWorkOrderDiscount || 0).toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid
                  container
                  spacing={2}
                  display={"end"}
                  justifyContent={"flex-end"}
                >
                  <Grid item lg={2} md={2} sm={4} xs={8} textAlign={"end"}>
                    <Typography style={{fontWeight:'bold'}}>
                      Grand Total :
                    </Typography>
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={4} textAlign={"end"}>
                    <Typography style={{fontWeight:'bold'}} >
                      {"$"}
                      {Number(order.quoteWorkOrderSaleGrandTotal || 0).toFixed(
                        2
                      )}
                   
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );


        

        return {
          label: label,
          description: description,
        };
      });






  
//   if (bamboraTransactionData && bamboraTransactionData.length > 0) {
//     bamboraTransactionData.forEach((transaction) => {
//       steps.push({
//         label: "Payment Successful",
//         description: (
//           <div>
//             <Typography variant="body1">
//               <strong>Transaction ID:</strong> {transaction.trnId}
//               <br />
//               <strong>Amount:</strong> ${transaction.trnAmount}
//               <br />
//               <strong>Date</strong>{" "}
//               {transaction.trnDate && transaction.trnTime ? (
//   <>
//     {moment(transaction.trnDate).format('MMM DD, YYYY')} at {moment(transaction.trnTime, 'HH:mm:ss').format('hh:mm A')}
//   </>
// ) : (
//   ""
// )}
//             </Typography>
//           </div>
//         ),
//       });
//     });
//   }

//   if (declinedTransaData && declinedTransaData.length > 0) {
//     declinedTransaData.forEach((transaction) => {
//       steps.push({
//         label: "Payment Declined",
//         description: (
//           <div>
//             <Typography variant="body1">
//               <strong>Transaction ID:</strong> {transaction.trnId}
//               <br />
//               {/* <strong>Reason:</strong> {transaction.messageText || "N/A"}
//               <br /> */}
//               <strong>Date:</strong>{" "}
//               { transaction.created_at
//                   ? moment(transaction.created_at).format("MMM DD, YYYY, hh:mm a")
//                   : ""}
             
//             </Typography>
//           </div>
//         ),
//       });
//     });
//   }

if (
  assignDriverHistoryData && 
  Array.isArray(assignDriverHistoryData.data) && 
  assignDriverHistoryData.data.length > 0
) {
  assignDriverHistoryData.data.forEach((driverEvent) => {
    // Ensure assign_to is an array
    const assignedDrivers = Array.isArray(driverEvent.assign_to) ? driverEvent.assign_to : [];

    // Find matching drivers from driverList
    const assignedDriverNames = assignedDrivers
      .map((driverObj: any) => {
        const matchedDriver = driverList.find((driver) => driver.id === driverObj.driverId);
        return matchedDriver ? `${matchedDriver.driverFirstName} ${matchedDriver.driverLastName}` : "Unknown Driver";
      })
      .join(", "); // Convert array to a string
     // Convert array to a string

    //   console.log("Driver List:", driverList);
    // console.log("Assigned Drivers:", assignedDrivers);
    // console.log("Resolved Driver Names:", assignedDriverNames);

      const assignedDate = driverEvent?.created_at
      ? dayjs(driverEvent.created_at).format("MMM D, YYYY [at] h:mm A")
      : "";

    steps.push({
      label: `Driver Assigned`, 
      description: (
        <div>
          <Typography variant="body1">
            <strong>Assigned Driver: </strong> {assignedDriverNames}
          </Typography>
          <Typography variant="body1">
            <strong>Assigned By: </strong> {driverEvent.updated_by}
          </Typography>
          <Typography variant="body1">
            <strong>Assigned At: </strong>{" "}
            {driverEvent?.created_at
              ? dayjs(driverEvent.created_at).format("MMM D, YYYY [at] h:mm A")
              : ""}
          </Typography>
        </div>
      ),
    });
  });
}


  return steps;
}


    return [];
  }, [workOrderHistoryData,bamboraTransactionData, declinedTransaData, assignDriverHistoryData, driverList]);

  const stripHtmlTags = (html: string) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };

  const toggleStepDetails = (index: number) => {
    if (expandedSteps.includes(index)) {
      setExpandedSteps(
        expandedSteps.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedSteps([...expandedSteps, index]);
    }
  };

  const toggleStepDetail = (index: number) => {
    if (expandedStep.includes(index)) {
      setExpandedStep(
        expandedStep.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedStep([...expandedSteps, index]);
    }
  };

  const toggleStepInvoice = (index: number) => {
    if (expandedStepsInvoice.includes(index)) {
      setExpandedStepsInvoice(
        expandedStepsInvoice.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedStepsInvoice([...expandedStepsInvoice, index]);
    }
  };

  const coursings = Array.isArray(WorkOrderDataList?.quoteWorkOrderSale)
    ? WorkOrderDataList!.quoteWorkOrderSale
    : [];

    const invoiceCoursings = Array.isArray(invoiceList?.quoteWorkOrderSale)
    ? invoiceList!.quoteWorkOrderSale
    : [];

    // const invoiceCoursings = invoiceList.flatMap((invoice) =>
    //   Array.isArray(invoice.quoteWorkOrderSale) ? invoice.quoteWorkOrderSale : []
    // );
    
  

  // const activeStep = WorkOrderDataList?.quoteWorkOrderStatus || 0;

  useEffect(() => {
    if (WorkOrderDataList) {
         if (dueAmount > 0) {
      setActiveStep(3);
    } else {
      setActiveStep(WorkOrderDataList.mainStatus || 0);
    }
     
    }
  }, [WorkOrderDataList, dueAmount]);

    useEffect(() => {
        let newTotalPrice = 0;
        let newTotalTax = 0;
      
        coursings.forEach((product) => {
          newTotalPrice += product.price ?? 0; // Sum of product prices
          newTotalTax += product.taxAmount ?? 0; // Sum of tax amounts
        });
      
        setTotalPrice(newTotalPrice); // Update state with new total price
        setTotalTax(newTotalTax); // Update state with new total tax
      }, [coursings, totalPrice, totalTax]);

      useEffect(() => {
        let newTotalPrice = 0;
        let newTotalTax = 0;
      
        // Calculate totals for invoiceList
        invoiceCoursings.forEach((product: any) => {
          newTotalPrice += product.price ?? 0; // Sum of invoice prices
          newTotalTax += product.taxAmount ?? 0; // Sum of invoice tax amounts
        });
      
        setInvoiceTotalPrice(newTotalPrice); // Update state with new total price for invoices
        setInvoiceTotalTax(newTotalTax); // Update state with new total tax for invoices
   //console.log(newTotalPrice)
      }, [invoiceList, invoiceTotalPrice, invoiceTotalTax  ]);

  const handleWorkOrder = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleConfirmDialog = () => {
    setOpen(false);
    proceedWithInvoiceSuccess(poNumber);
   // proceedWithInvoiceSuccess();
  };

  const handleOpenModal = (file: string): void => {
    const url = `${LARAVEL_API_URL}/${file}`;
    setFileUrl(url);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setFileUrl(null);
  };

  const proceedWithInvoiceSuccess = (poNumber: string) => {
    setActiveStep((prevStep) => prevStep + 1);

    const newMainStatus =
      WorkOrderDataList?.mainStatus === 1
        ? WorkOrderDataList.mainStatus + 1
        : "";

    setMainStatus(String(newMainStatus));
    setId(WorkOrderDataList?.id ? String(WorkOrderDataList.id) : id);
    setPoNumber(poNumber.trim() ? poNumber : ""); 
    // if (updateData) {
    //   showMessage("Converted to invoice successfully");
    // } else if (updateError) {
    //   showErrorMessage("Failed to convert to invoice");
  
    // }
    setTimeout(() => {
      workOrderHistoryRefetch();  // Refetch history
      invoiceRefetch();    
      invoiceHistoryRefetch();       // Refetch invoice
    }, 2000); 
  };


 

  // React.useEffect(() => {
  //   if (!updateIsLoading && !updateError && UpdateStatusInvoiceDataList) {
  //     navigate(`/invoice/history/${UpdateStatusInvoiceDataList.invoiceId || null}`);
  //   }
  // }, [updateIsLoading, updateError, UpdateStatusInvoiceDataList, navigate]);

  const handlePayment = () => {

 
    // const invoice = invoiceList.find(
    //   (invoice) => invoice.quoteWorkOrderNo === WorkOrderDataList?.quoteWorkOrderNo
    // );

      setActiveStep((prevStep) => prevStep + 1); 
      //setShowPaymentDetails(true);  // Show the payment details dialog 
   

  };
  

  const handleOnRoute = () => {
    
     setShowDriverDialog(true);
   
  };

  const handleDeliverComplete = () => {
    // Parse assigned drivers
    const assignedDrivers: { driverId: number; price: number; hourPrice: number }[] = 
      invoiceList.assign_driver.assign_to 
        ? JSON.parse(invoiceList.assign_driver.assign_to) 
        : [];
  
    // Check if all assigned drivers have a valid price
    const allDriversHavePrices = assignedDrivers.every(
      (driver) => driver.price !== undefined && driver.price > 0
    );
  
    if (!allDriversHavePrices) {
      showErrorMessage("Please enter a trip price for all assigned drivers.");
      return; // Stop further execution
    }
  
    try {
      const headers = {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };

      const updatePayload = {
        QuoteId: QuoteId,
    };

    
       const response =  axios.post(`${API_URL}/update-completed-status`, updatePayload, { headers });
       workOrderRefetch();
       setActiveStep((prevStep) => prevStep + 1);
      //  showMessage("Price saved successfully");


  } catch (error) {
      console.error("Error updating completed status:", error);
     showErrorMessage("Failed to update completed status.");
  }
  
    
  };
  
  

    const getNextButtonLabel = () => {
      switch (activeStep) {
        case 0:
          return "Convert to Invoice";
        case 1:
          return "Convert to Invoice";
        case 2:
          return "Process Payment";
          //return null;
        case 3:
          return "On Route";
        case 4:
          return "Complete Trip";
        default:
          return "Finish";
      }
    };

    const handleNext = () => {
      switch (activeStep) {
        case 0:
          handleWorkOrder();
          break;
        case 1:
          handleOpenDialog();
          break;
        case 2:
          handlePayment();
          break;
        case 3:
          handleOnRoute();
          break;
        case 4:
          handleDeliverComplete();
          break;
        default:
          break;
      }
    };

    const handleProcessPayment = () => {
      handlePayment();
      // Optionally move to the next step after payment
      // setActiveStep(3); // Move to On Route
    };
    

    const handleSelectDriver = (driverId: number) => {
      const busCountFromInvoice = invoiceList?.quoteWorkOrderSale?.[0]?.busCount;
    
      if (!busCountFromInvoice) {
        console.warn("No busCount found in the invoiceList.quoteWorkOrderSale.");
        return;
      }
    
      setSelectedDrivers((prev) => {
        const existingDriver = prev.find((d) => d.id === driverId);
    
        if (existingDriver) {
          // Remove the driver if already selected
          return prev.filter((d) => d.id !== driverId);
        } else {
          // Add the driver only if the limit has not been reached
          if (prev.length < busCountFromInvoice) {
            return [...prev, { id: driverId, price: 0, hourPrice: 0 }];
          }
        }
    
        return prev;
      });
    };
    
    
    const handleInputChange = (driverId: number, field: "price" | "hourPrice", value: number) => {
      setSelectedDrivers((prev) =>
        prev.map((d) => 
          d.id === driverId ? { ...d, [field]: value } : d
        )
      );
    };
    

   
        const handleAssignDriver = async () => {
      
        try {
            const headers = {
                Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
            };
      
            const updatePayload = {
              drivers: selectedDrivers.map((driver) => ({
                  driverId: driver.id, 
                  price: driver.price, 
                  hourPrice: driver.hourPrice
              })),
              QuoteId: QuoteId,
          };
            const response = await axios.post(`${API_URL}/assign-driver`, updatePayload, { headers });
        
            await handleSendDriverEmail();
            invoiceRefetch();
            assignDriverHistoryRefetch();
            showMessage("Assigned driver successfully and email sent to driver(s).");

            // if (WorkOrderDataList?.mainStatus !== undefined) {
            //   const newMainStatus = (WorkOrderDataList.mainStatus || 0) + 2; // Update status
            //   setMainStatus(String(newMainStatus)); // Update the state with the new status
            // }
            setSelectedDrivers([]);
            handleDriverDialogClose();
            if (shouldIncrementStep) {
              setActiveStep((prevStep) => prevStep + 1);
            }
          

        } catch (error) {
            console.error("Error assigning driver:", error);
           showErrorMessage("Failed to assign driver.");
        }
      
    };

    const handleOpenPriceDialog = (driverId: number) => {
      // Find the selected driver from driverList
      const driverData = driverList.find(driver => driver.id === driverId);
    
      if (!driverData) return; // Ensure it's not undefined
    
      const assignedDrivers = invoiceList.assign_driver?.assign_to
      ? JSON.parse(invoiceList.assign_driver.assign_to)
      : [];

      const driverAssignment = assignedDrivers.find((d: any) => d.driverId === driverId);
      // Set the selected driver details
      setSelectedDriverId(driverData.id);

      if (driverAssignment) {
        setTripPrice(driverAssignment.price?.toString() || ""); // Ensure it's a string
        setHourPrice(driverAssignment.hourPrice?.toString() || ""); // Ensure it's a string
      } else {
        setTripPrice(tripPrice.toString());
        setHourPrice(hourPrice.toString());
      }
    
    
      const fullName = `${driverData.driverFirstName} ${driverData.driverLastName}`;
      setSelectedDriverName(fullName);
      // Open the price dialog
      setIsPriceDialogOpen(true);
    };
    
    

    const handleSavePrice = async () => {

       try {
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        };
  
        const updatePayload = {
          driverId: selectedDriverId,
          price: parseFloat(tripPrice),
          hourPrice: parseFloat(hourPrice),
          QuoteId: QuoteId,
      };

      
         const response = await axios.post(`${API_URL}/update-driver-price`, updatePayload, { headers });
         
         invoiceRefetch();
         showMessage("Price saved successfully");
         handleClosePriceDialog();

    } catch (error) {
        console.error("Error assigning price:", error);
       showErrorMessage("Failed to assign price.");
    }
    
      }
  

    const handleClosePriceDialog = () => {
      setIsPriceDialogOpen(false);
      setSelectedDriverId(null);
      setTripPrice('');
      setHourPrice('');
    };


    const handleClosePoNumberDialog = () => {
      setIsPoNumberDialogOpen(false);
      setPoNumber("");
    };
    

  const isLoading =
    workIsLoading || updateIsLoading || workOrderHistoryIsLoading;

  useEffect(() => {
    if (!updateIsLoading) {
      workOrderRefetch();
    }
  }, [updateIsLoading, workOrderRefetch]);

  useEffect(() => {
    if (!workOrderHistoryIsLoading) {
      workOrderHistoryRefetch();
    }
  }, [workOrderHistoryIsLoading, workOrderHistoryRefetch]);

  useEffect(() => {
  
//console.log(invoiceList)
  }, [invoiceList]);

  

  const discountList = Array.isArray(
    WorkOrderDataList?.quoteWorkOrderSaleDiscountDescription
  )
    ? WorkOrderDataList!.quoteWorkOrderSaleDiscountDescription
    : [];

    const invoiceDiscountList = Array.isArray(
      invoiceList?.quoteWorkOrderSaleDiscountDescription
    )
      ? invoiceList!.quoteWorkOrderSaleDiscountDescription
      : [];

    // const invoiceDiscountList = invoiceList.flatMap((history) =>
    //   Array.isArray(history.quoteWorkOrderSaleDiscountDescription)
    //     ? history.quoteWorkOrderSaleDiscountDescription
    //     : []
    // );

    const handleShowMore = () => {
      setShowAllDrivers(!showAllDrivers);
    };
    

  if (isLoading || workIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  const convertPlainTextToHTML= (text: string) => {
    return text
      .replace(/\n/g, '<br>') // Replace line breaks with <br>
      .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length)); // Replace multiple spaces with &nbsp;
  }

  const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditableAmount(event.target.value);
  };

  const handleSendPaymentLink = () => {
     //updateInvoiceAmount(amount);
   // updateInvoiceAmount(Number(editableAmount));

    setShowEmailDialog(true); // Close the dialog after submission
   // setInvoiceEmailData({ ...invoiceEmailData, to: WorkOrderDataList?.customer.customerEmail });
  };

  const handleOpenDriverDialog = (driver: any) => {
   
    setDriverEmailData({
      ...driverEmailData,
      to: driver.driverEmail || "", // Set the driver's email in the "To" field
    });
    handleReSendDriverEmail(driver);
   //setShowDriverEmailDialog(true); // Close the dialog after submission
  // setInvoiceEmailData({ ...invoiceEmailData, to: WorkOrderDataList?.customer.customerEmail });
 };



  const handleReSendPaymentLink = () => {


    const paymentTemplate = emailTemplateList.find(
      (template) => template.template_name === "Payment Link"
    );
  
    setInvoiceEmailData({
      to: WorkOrderDataList?.customer.customerEmail || "",
      template: paymentTemplate?.id?.toString() || "", // Set the Payment template ID
      subject: paymentTemplate?.subject || "Payment Reminder", // Use template subject or fallback
      message: paymentTemplate?.message || "Please find the payment details attached.", // Use template message or fallback
    });
  
    setShowEmailDialog(true); // Close the dialog after submission
   // setInvoiceEmailData({ ...invoiceEmailData, to: WorkOrderDataList?.customer.customerEmail });
  };

  const handleEmailDialogClose = () => setShowEmailDialog(false);

  const handleDriverEmailDialogClose = () => setShowDriverEmailDialog(false);

  const handleDriverDialogClose = () => setShowDriverDialog(false);

  const handlePaymentDialogClose = () => setShowPaymentDialog(false);

  const handleSendDriverEmail = async () => {
    setLoading(true);
  
    try {

      const selectedTemplate = emailTemplateList.find(
        (template) => template.template_name === "Trip Assignment"
      );
      if (!selectedTemplate) {
        throw new Error("Template 'Trip Assignment' not found");
    }
 // Gather data from invoiceCoursings and invoiceList
 let busType = "";
 let transferType = ""; // Leave empty to fetch dynamically from data
 let transferFrom = ""; // Leave empty to fetch dynamically from data
 let transferTo = ""; // Leave empty to fetch dynamically from data
 let departureAddress = ""; // Leave empty to fetch dynamically from data
 let departureDate = ""; // Leave empty to fetch dynamically from data
 let destinationAddress = ""; // Leave empty to fetch dynamically from data
 let destinationDate = ""; // Leave empty to fetch dynamically from data

 // Iterate through each product in invoiceCoursings
 invoiceCoursings.forEach((product: any) => {
     busType = product.productName || "Bus";
     transferType = product.transferType
     ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
         .find((key) => TransferType[key] === String(product.transferType)) ?? "Default Transfer Type"
     : "Default Transfer Type"; // Dynamically set transferType


 // Use a default transferType if none was found

     transferFrom = product.transferTypeFrom || transferFrom; // Dynamically set transferFrom
     transferTo = product.transferTypeTo || transferTo; // Dynamically set transferTo
     departureAddress = product.departureAddress || departureAddress; // Dynamically set departureAddress
     departureDate = dayjs(product.departureDateTime).format("DD-MMM-YY hh:mm A")|| departureDate; // Dynamically set departureDate
     destinationAddress = product.destinationAddress || destinationAddress; // Dynamically set destinationAddress
     destinationDate = dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A") || destinationDate; // Dynamically set destinationDate
     destinationDate = product.returnDateTime
     ? dayjs(product.returnDateTime).isValid()
       ? dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")
       : ""
     : "";
   

  });

 const driverDetails = selectedDrivers
  .map((driverId) => {
    const driver = driverList?.find((driver) => driver.id === driverId.id);
    return driver
      ? {
          email: driver.driverEmail,
          firstName: driver.driverFirstName || "Driver",
          lastName: driver.driverLastName || "",
        }
      : null;
  })
  .filter((driver): driver is { email: string; firstName: string; lastName: string } => driver !== null); // Type assertion to let TS know the array contains only valid drivers

  const driverEmails = driverDetails.map((driver) => driver.email);  // Array of individual driver emails


 // Prepare the data object for template replacement
 for (let driver of driverDetails) {
  // Prepare email data with the individual driver's first name
  const data = {
    driverFirstName: driver.firstName, // Assign first name of the current driver
    busType,
    transferType,
    transferFrom,
    transferTo,
    departureAddress,
    departureDate,
    destinationAddress,
    destinationDate,
  };

 // Replace placeholders in the selected template
 const emailMessage = selectedTemplate?.message
     ? replaceTemplatePlaceholders(selectedTemplate.message, data)
     : "";


  

        const emailData = {
    customer_id: WorkOrderDataList ? parseInt(WorkOrderDataList.quoteWorkOrderCustomerId, 10) : 0,
    workOrderNo: WorkOrderDataList ? WorkOrderDataList.quoteWorkOrderNo : "",
    subject: selectedTemplate?.subject || "Trip Assignment",
    message: convertPlainTextToHTML(emailMessage), // Ensure message is in HTML format
};
 
       
const formData = new FormData();
formData.append("customer_id", emailData.customer_id.toString());
formData.append("workOrderNo", emailData.workOrderNo);
formData.append("to", driver.email);
formData.append("subject", emailData.subject);
formData.append("message", emailData.message);

  const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  };

  try {
    const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

    if (emailResponse.status === 200) {
        // Email sent successfully
        console.log("Email sent successfully");
        fetchEmailLogs();
    } else {
        // Error response from the server
        console.error("Failed to send email");
        showErrorMessage(`Failed to send email`);
    }
} catch (error) {
    console.error("Error during email sending:", error);
    showErrorMessage(`Failed to send email `);
}
}

setDriverEmailData({ ...driverEmailData, subject: "", message: "" });

           
} catch (error) {
  console.error("Error during email handling:", error);
  showErrorMessage("Failed to send emails");
} finally {
  handleEmailDialogClose();
  setLoading(false);
}
};

const replaceTemplatePlaceholders = (template: string, data: any) => {
  let result = template
    .replace("[driver_name]", data.driverFirstName)
    .replace("[bus_type]", data.busType)
    .replace("[transfer_type]", data.transferType)
    .replace("[transfer_from]", data.transferFrom)
    .replace("[transfer_to]", data.transferTo)
    .replace("[departure_address]", data.departureAddress)
    .replace("[departure_date]", data.departureDate)
    .replace("[destination_address]", data.destinationAddress);

  // Only replace [destination_date] if it exists
  result = data.destinationDate
    ? result.replace("[destination_date]", data.destinationDate)
    : result.replace("([destination_date])", ""); // Remove () when no return date

  return result;
};


const handleReSendDriverEmail = async (driver: any) => {
 // setLoading(true);
  setLoadingStates((prev) => ({ ...prev, [driver.id]: true }));

  try {
    // Ensure a template is selected
    const selectedTemplate = emailTemplateList.find(
      (template) => template.id === Number(driverEmailData.template)
    );

    if (!selectedTemplate) {
      throw new Error("Please select an email template.");
    }

    // Gather details for email
    let busType = "";
    let transferType = "";
    let transferFrom = "";
    let transferTo = "";
    let departureAddress = "";
    let departureDate = "";
    let destinationAddress = "";
    let destinationDate = "";

    invoiceCoursings.forEach((product: any) => {
      busType = product.productName || "Bus";
      transferType = product.transferType
        ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find(
            (key) => TransferType[key] === String(product.transferType)
          ) ?? "Default Transfer Type"
        : "Default Transfer Type";

      transferFrom = product.transferTypeFrom || transferFrom;
      transferTo = product.transferTypeTo || transferTo;
      departureAddress = product.departureAddress || departureAddress;
      departureDate = product.departureDateTime
        ? dayjs(product.departureDateTime).format("DD-MMM-YY hh:mm A")
        : departureDate;
      destinationAddress = product.destinationAddress || destinationAddress;
      destinationDate = product.returnDateTime
        ? dayjs(product.returnDateTime).isValid()
          ? dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")
          : ""
        : destinationDate;
    });

    const driverDetails = {
      email: driver.driverEmail,
      firstName: driver.driverFirstName || "Driver",
      lastName: driver.driverLastName || "",
    };

    if (!driverDetails.email) {
      throw new Error("Driver email is missing.");
    }

    const data = {
      driverFirstName: driverDetails.firstName,
      busType,
      transferType,
      transferFrom,
      transferTo,
      departureAddress,
      departureDate,
      destinationAddress,
      destinationDate,
    };

    const emailMessage = replaceTemplatePlaceholders(selectedTemplate.message, data) || "";
    const emailData = {
      customer_id: WorkOrderDataList ? parseInt(WorkOrderDataList.quoteWorkOrderCustomerId, 10) : 0,
      workOrderNo: WorkOrderDataList ? WorkOrderDataList.quoteWorkOrderNo : "",
      subject: driverEmailData.subject || selectedTemplate.subject,
      message: convertPlainTextToHTML(emailMessage),
    };

    const formData = new FormData();
    formData.append("customer_id", emailData.customer_id.toString());
    formData.append("workOrderNo", emailData.workOrderNo);
    formData.append("to", driverDetails.email);
    formData.append("subject", emailData.subject);
    formData.append("message", emailData.message);

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };

    try {
      const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

      if (emailResponse.status === 200) {
        showMessage(`Email sent successfully`)
        console.log(`Email sent successfully to ${driverDetails.email}`);
      } else {
        console.error(`Failed to send email to ${driverDetails.email}`);
      }
    } catch (error) {
      console.error(`Error sending email to ${driverDetails.email}:`, error);
    }

    fetchEmailLogs();
  } catch (error) {
    console.error("Error during email sending:", error);

    if (error instanceof Error) {
      showErrorMessage(error.message);
    } else {
      showErrorMessage("Failed to send email.");
    }
  } finally {
    //setLoading(false);
    setLoadingStates((prev) => ({ ...prev, [driver.id]: false })); // Reset loading
    handleDriverEmailDialogClose();
  }
};

const handleOpenViewQuote = (transactionId: string) => {
  setWorkOrderId(transactionId);
  setOpenViewQuote(true);
  //console.log(transactionId);
};

const handleCloseViewQuote = () => {
  setOpenViewQuote(false);
  setWorkOrderId("");
};

   const handleOpenViewInvoice = (transactionId: string) => {
      
        setInvoiceId(transactionId);
        setOpenViewInvoice(true);
      };

       const handleCloseViewInvoice = () => {
        setOpenViewInvoice(false);
        setInvoiceId("");
      };


const handleAddPoNumber = (invoiceNo: string) => {
   setIsPoNumberDialogOpen(true);
  // const newPoNumber = prompt(`Enter PO Number for ${invoiceNo}`);
  // if (newPoNumber?.trim()) {
  //   updateInvoicePoNumber(newPoNumber);
  // }
};


const updateInvoicePoNumber = async (poNumber: string) => {
  setLoading(true);
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  };

  const updatePayload = {
    workOrderNo: WorkOrderDataList?.quoteWorkOrderNo,
      po_number: poNumber,
  };

  await axios.put(`${API_URL}/update-po-number`, updatePayload, { headers });

 //   await api.updateInvoice({ invoiceNo, po_number: poNumber });
    showMessage("PO Number added successfully!");
    invoiceRefetch(); // ✅ Refresh invoice list
  } catch (error) {
    showErrorMessage("Failed to update PO Number.");
  }
  handleClosePoNumberDialog();
  setLoading(false); 
};




  const handleSendEmail = async () => {
    setLoading(true);
  
    try {
        

      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };

        const customerFirstName =  WorkOrderDataList?.customer.customerFirstName || "Customer";
      
   const paymentFormData = new FormData();
      paymentFormData.append("invoice_id",  String(WorkOrderDataList?.invoiceId));
      paymentFormData.append("customer_id", String(WorkOrderDataList?.quoteWorkOrderCustomerId));
      paymentFormData.append("requested_amt", editableAmount);
      paymentFormData.append( "total_due", parseFloat(WorkOrderDataList?.quoteWorkOrderSaleGrandTotal ?? "0").toFixed(2),
      );


      const response = await axios.post(`${API_URL}/generate-payment-link`, paymentFormData, { headers });
  
      const paymentId = response.data.payment_link?.payment_id;
  
      if (!paymentId) throw new Error("Payment ID not returned.");
  
      const paymentLink = paymentId ? `${paymentUrl}/${paymentId}` 
      : "No payment link available.";

      
        // const paymentLink = WorkOrderDataList?.payment_id
        //       ? `${paymentUrl}/${WorkOrderDataList.payment_id}`
        //       : "No payment link available.";

      
              const updatedMessage = invoiceEmailData.message
              ? invoiceEmailData.message
                  .replace(/\[customer_name\]/g, customerFirstName)
                  .replace(/\[payment_link\]/g, paymentLink)
                  .replace(/\[amount\]/g, editableAmount)
                  .replace(/\[total_due\]/g, (parseFloat(WorkOrderDataList?.quoteWorkOrderSaleGrandTotal ?? "0") - (amountPaid ?? 0)).toFixed(2))
              : ''; // Fallback to empty string if message is undefined

        const emailData = {
            customer_id: WorkOrderDataList ? parseInt(WorkOrderDataList.quoteWorkOrderCustomerId, 10) : 0,
            workOrderNo: WorkOrderDataList ? WorkOrderDataList.quoteWorkOrderNo : "",
            amount: editableAmount,
            to: invoiceEmailData.to,
            subject: invoiceEmailData.subject,
            //message: invoiceEmailData.message,
            message: convertPlainTextToHTML(updatedMessage),
            
        };
 

        // Create FormData object
        const formData = new FormData();
        formData.append("customer_id", emailData.customer_id.toString());
        formData.append("workOrderNo", emailData.workOrderNo);
        formData.append("amount", emailData.amount.toString());
        formData.append("to", emailData.to);
        formData.append("subject", emailData.subject);
        formData.append("message", emailData.message);

        
        const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

        if (emailResponse) {
        
            showMessage("Email sent successfully");
            fetchEmailLogs(); 
         //   await refetchActivityHistory();
          //  setInvoiceEmailData({ ...invoiceEmailData, subject: "", message: "" });
           
        } else {
            showErrorMessage("Failed to send email");
        }
    } catch (error) {
        console.error("Error during email sending:", error);
        showErrorMessage("Failed to send email");
    } finally {
        handleEmailDialogClose();
        setLoading(false);
    }
};

const handleSavePayment = async () => {

if (!paymentData.paymentMethod) {
  setShowPaymentMethodError(true);
  return;
}
  setLoading(true);

  
setShowPaymentMethodError(false);


  try {
    const formData = new FormData();
    formData.append("work_order_id", QuoteId || "defaultQuoteId");
    formData.append("invoice_id", String(WorkOrderDataList?.invoiceId));
    formData.append("customer_id", String(WorkOrderDataList?.quoteWorkOrderCustomerId));
    formData.append("amount", paymentData.amount);
    formData.append("paymentDate", paymentData.paymentDate);
    formData.append("paymentMethod", paymentData.paymentMethod);
    formData.append("description", paymentData.description);
    formData.append("payment_mode", 'OFFLINE'); // Add payment mode as Offline
    if (paymentData.file) {
      formData.append("file", paymentData.file);
    }

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };

    // Send the formData to the backend
    const paymentResponse = await axios.post(`${API_URL}/save-payment`, formData, { headers });

    if (paymentResponse && paymentResponse.data) {
      showMessage("Payment saved successfully");
      // Fetch email logs or refetch activity history here if needed
      setTimeout(() => {
        invoiceRefetch(); 
             
      }, 1000); 
      fetchPayments();
   //  await invoiceRefetch();
      setPaymentData({ paymentDate: getCurrentDateCanada(),amount: "", paymentMethod: "", description: "", file: null });
    } else {
      showErrorMessage("Failed to process payment");
    }
  } catch (error) {
    console.error("Error during payment saving", error);
    showErrorMessage("Failed to process payment");
  } finally {
    handlePaymentDialogClose();
    setLoading(false);
  }
};


const updateInvoiceAmount = async (amount: number) => {
  try {
      const headers = {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };

      const updatePayload = {
          workOrderNo: WorkOrderDataList?.quoteWorkOrderNo,
          amount: amount,
          invoice_id: WorkOrderDataList?.id,
          customer_id: WorkOrderDataList?.quoteWorkOrderCustomerId,
          total_due: WorkOrderDataList?.quoteWorkOrderSaleGrandTotal,
          payment_id: WorkOrderDataList?.payment_id,
      };

      await axios.put(`${API_URL}/`, updatePayload, { headers });

    //  showMessage("Invoice amount updated successfully.");
  } catch (error) {
      console.error("Error updating invoice amounupdate-invoice-amountt:", error);
    //  showErrorMessage("Failed to update invoice amount.");
  }
};




const handlePaymentPopup = () => {
  setShowPaymentDialog(true);
};

// const handleEmailCheck = async() => {
//   const response = await axios.post(`${API_URL}/trigger-email`);
//   console.log(response)
// };

  return (
    <div>
      {isLoading ? (
        <div>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="10vh"
          >
            <CircularProgress />
          </Box>
        </div>
      ) : (
        <>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={1}
                          sx={{ padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.h4Quoto}>
                              <strong>
                                <span className={classes.customerDetails}>
                                  {(WorkOrderDataList?.quoteWorkOrderNo ||
                                    " ") + " "}
                                </span>

                                {invoiceList?.InvoiceNo && (
      <span className={classes.customerDetails}>
       <Box component="span">
          <span style={{ fontSize: '16px' }}>➔</span> {/* Beautiful arrow */}
          {" " + invoiceList.InvoiceNo} 
          {invoiceList.po_number ? (
        ` (${invoiceList.po_number})` // ✅ Show PO number if available
      ) : (

        <span
        style={{
          backgroundColor: '#007BFF',
          color: '#fff',
          borderRadius: '6px',
          padding: '2px 8px',
          marginLeft: '8px',
          fontSize: '0.9rem',
          fontWeight: '500',
          cursor: 'pointer',
        }}
        onClick={() => handleAddPoNumber(invoiceList.InvoiceNo)}
       //  onClick={() =>
       //   navigate(`/work-order/history/${transaction.work_order_id}`)
       // }
      >
      Add PO no
      </span>

      
      )}
        </Box>
      </span>
    )}


                                <span className={classes.customerDetails}>
                                  {" "}
                                </span>

                                <span className={classes.customerDetails}>
                                  {/* Using Box to add margin-left */}
                                  <Box component="span" ml={2}>
                                    {" "}
                                    {/* Adjust the "ml" value as needed */}
                                    <Button
  className={classes.statusButtonListWorkOrderList}
  style={{
    color: getStatusColor(
      invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus ?? 0
    ),
    border: "solid 1px",
    borderColor: getStatusColor(
      invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus ?? 0
    ),
    borderRadius: "8px",
    backgroundColor:
      (invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus) === WorkOrderStatus.Paid
        ? "#e1f8d5"
        : (invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus) === WorkOrderStatus.Cancel
        ? "#f8d7da"
        : (invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus) === WorkOrderStatus.Pending
        ? "lightyellow"
        : (invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus) === WorkOrderStatus.Initiated
        ? "#e2fafa"
        : "#ffffff", // Fallback for other statuses
  }}
>
  {getStatusLabel(invoiceList?.quoteWorkOrderStatus ?? WorkOrderDataList?.quoteWorkOrderStatus ?? 0)}
</Button>

                                  </Box>
                                </span>
   { dueAmount > 0 &&  (
                                <span
                                 style={{
                                   backgroundColor: '#007BFF',
                                   color: '#fff',
                                   borderRadius: '6px',
                                   padding: '2px 8px',
                                   marginLeft: '8px',
                                   fontSize: '0.9rem',
                                   fontWeight: '500',
                                   cursor: 'pointer',
                                 }}
                                 onClick={handlePaymentPopup}
                                //  onClick={() =>
                                //   navigate(`/work-order/history/${transaction.work_order_id}`)
                                // }
                               >
                               Pay
                               </span>
   )}
                              </strong>
                            
                            </Typography>
                          </Grid>
                          {/* <button onClick={handleEmailCheck}>email</button> */}
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.h5}>
                              <Typography component="span">
                                Order / Order Details /
                              </Typography>{" "}
                              <Typography component="span">
                                {WorkOrderDataList?.quoteWorkOrderNo || ""} /
                              </Typography>{" "}
                              <Typography component="span">
                                {WorkOrderDataList?.created_at
                                  ? dayjs(WorkOrderDataList.created_at).format(
                                      "MMM D, YYYY [at] h:mm A"
                                    )
                                  : ""}
                              </Typography>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={1}
                          className={classes.titleGrid}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: 2,
                          }}
                        >
                             <Grid item>
  <Button
    variant="contained"
    className={classes.editButtonList}
    component={Link}
    to={
      WorkOrderDataList?.invoiceId
        ? WorkOrderDataList?.quoteWorkOrderCustomerProjectId
          ? `/invoice/project/edit/${WorkOrderDataList?.invoiceId}`
          : `/invoice/edit/${WorkOrderDataList?.invoiceId}`
        : `/quote-history/${WorkOrderDataList?.id}`
    }
  >
    <EditSharpIcon className={classes.editListIcon} />
  </Button>
</Grid>
                          <Grid item>
                            <Button className={classes.refundButton}>
                              Refund
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button className={classes.refundButton}>
                              Terminate
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              startIcon={
                                // WorkOrderDataList?.mainStatus === 1 ? (
                                //   <EditSharpIcon />
                                // ) : (
                                  <VisibilitySharpIcon />
                                // )
                              }
                              className={classes.addButton}
                              // onClick={() =>
                              //   navigate(
                              //     `/quote-history/${WorkOrderDataList?.id}`
                              //   )
                              // }
                              onClick={() => handleOpenViewQuote(String(WorkOrderDataList?.id))}
                            >
                              Quote
                            </Button>
                          </Grid>
                          {WorkOrderDataList?.mainStatus != 1 && (
                            <Grid item>
                              <Button
                                variant="contained"
                                startIcon={<VisibilitySharpIcon />}
                                className={classes.addButton}
                                onClick={() => handleOpenViewInvoice(String(WorkOrderDataList?.invoiceId))}
                                // onClick={() =>
                                //   navigate(
                                //     `/invoice/history/${WorkOrderDataList?.invoiceId}`
                                //   )
                                // }
                              >
                                Invoice
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={1}
                          sx={{ padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            {/* <Typography className={classes.h4Quoto}>
                              <strong>Progress</strong>
                            </Typography> */}
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                           <Box sx={{ width: "100%", overflowX: "auto" }}>
                              <Stepper
                                activeStep={activeStep}
                                alternativeLabel
                                // alternativeLabel={!isMobile}
                                // orientation={isMobile ? "vertical" : "horizontal"}
                                connector={<CustomStepConnector />}
                              >
                                {steps.map((label, index) => (
            <Step key={label}>
              <CustomStepLabel>
                <Typography variant="body1" fontWeight="bold">
                  {label}
                </Typography>

                {/* Show loading icon for active step */}
                {activeStep === index && (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 1 }}>
                    <CircularProgress size={20} />
                  </Box>
                )}

                {/* Display Step Details */}
              <Box sx={{ textAlign: "center", mt: 1 }}>

                  {activeStep > index && (
               <Box sx={{ mt: 1 }}>
  {/* Step 0: Created By / Created At */}
  {index === 0 && workOrderHistoryData && Array.isArray(workOrderHistoryData.data) && workOrderHistoryData.data.length > 0 && (
    <Box>
      <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'text.primary' }}>
        Created by: {workOrderHistoryData.data[0]?.updated_by}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
        {dayjs(workOrderHistoryData.data[0]?.created_at).format("MMM D, YYYY [at] h:mm A")}
      </Typography>
    </Box>
  )}

  {/* Step 1: Converted By / Converted At */}
  {index === 1 && invoiceHistories && Array.isArray(invoiceHistories) && invoiceHistories.length > 0 && (
    <Box>
      <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'text.primary' }}>
        Converted by: {invoiceHistories[0]?.updated_by}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
        {dayjs(invoiceHistories[0]?.created_at).format("MMM D, YYYY [at] h:mm A")}
      </Typography>
    </Box>
  )}

  {/* Step 2: Total Due / Paid Amount */}
  {index === 2 && (
    <Box>
      <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'text.primary' }}>
        Total due: ${parseFloat(invoiceList?.quoteWorkOrderSaleGrandTotal ?? "0").toFixed(2)}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
        Amount paid: {amountPaid}
      </Typography>
    </Box>
  )}

  {/* Step 3: Assigned By / Assigned At */}
  {index === 3 && invoiceList?.assign_driver  && (
    <Box>
 
 <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'text.primary' }}>
  Assigned by: {assignDriverHistoryData?.data && Array.isArray(assignDriverHistoryData.data) && assignDriverHistoryData.data.length > 0
    ? assignDriverHistoryData.data[assignDriverHistoryData.data.length - 1]?.updated_by || "N/A"
    : "No history available"}
</Typography>

      <Typography variant="body2" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
      {dayjs(invoiceList?.assign_driver?.updated_at).format("MMM D, YYYY [at] h:mm A") }
      </Typography>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          className={classes.addButton}   
          onClick={() => {
            setShouldIncrementStep(false);  // ✅ Set increment step to true
            setShowDriverDialog(true);
          }}
          sx={{
            fontSize: '0.75rem', // Smaller font size for the button text
            padding: '4px 8px',  // Reduced padding for a smaller button
            minWidth: 'auto',
            textTransform: 'none',
            marginTop: 2,
          }}
        >
          Assign
        </Button>
      </Grid>
    </Box>
  )}
</Box>

              
               
                )}

                    {/* {index === 0 && stepDetails[index] && (
                    <>
                      <Typography variant="body2">Created by: {stepDetails[index].createdBy}</Typography>
                      <Typography variant="body2">Created at: {stepDetails[index].createdAt}</Typography>
                    </>
                  )}
                  {index === 1 && stepDetails[index] && (
                    <>
                      <Typography variant="body2">Converted by: {invoiceList?.updated_by}</Typography>
                      <Typography variant="body2">Converted at: {invoiceList?.created_at}</Typography>
                    </>
                  )}
                  {index === 2 && stepDetails[index] && (
                    <>
                      <Typography variant="body2">Processed by: {stepDetails[index].processedBy}</Typography>
                      <Typography variant="body2">Processed at: {stepDetails[index].processedAt}</Typography>
                    </>
                  )}
                  {index === 3 && stepDetails[index] && (
                    <>
                      <Typography variant="body2">Assigned by: {stepDetails[index].assignedBy}</Typography>
                      <Typography variant="body2">Assigned at: {stepDetails[index].assignedAt}</Typography>
                    </>
                  )}
                  {index === 4 && stepDetails[index] && (
                    <>
                      <Typography variant="body2">Delivered by: {stepDetails[index].deliveredBy}</Typography>
                      <Typography variant="body2">Delivered at: {stepDetails[index].deliveredAt}</Typography>
                    </>
                  )}*/}
                </Box> 
              </CustomStepLabel>
            </Step>
          ))}
                              </Stepper>

                              {/* {activeStep === 2 && (
      <>
        <Button onClick={handleProcessPayment}>Process Payment</Button>
        <Button onClick={handleAssignDriver}>Assign Driver</Button>
      </>
    )} */}


                              {activeStep === steps.length ? (
                                <>
                                  <Typography sx={{ mt: 2, mb: 1 }}>
                                    completed
                                  </Typography>
                                </>
                              ) : (
                                <>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      mt: 2,
                                      mr: 2,
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      className={classes.addButton}
                                      onClick={handleNext}
                                    >
                                      {getNextButtonLabel()}
                                    </Button>
                                  </Box>
                                </>
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={8} md={8} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid container spacing={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              className={classes.h4Quoto}
                              sx={{ flexGrow: 1, textAlign: "center", cursor: "pointer", 
                              //  textDecoration: "underline", // Makes it look like a link
                              }}
                              style={{color: theme.palette.text.primary}}
                              onClick={() =>
                                navigate(
                                  `/customer-history/${
                                    WorkOrderDataList?.quoteWorkOrderCustomerId ||
                                    null
                                  }`
                                )
                              }
                            >
                             {(
    (WorkOrderDataList?.customer.customerFirstName || "")
      .charAt(0)
      .toUpperCase() + (WorkOrderDataList?.customer.customerFirstName || "").slice(1).toLowerCase()
  ) +
    " " +
    (
      (WorkOrderDataList?.customer.customerLastName || "")
        .charAt(0)
        .toUpperCase() + (WorkOrderDataList?.customer.customerLastName || "").slice(1).toLowerCase()
    )}
                            </Typography>
                            {/* <Button
                              variant="contained"
                              className={classes.viewButtonList}
                              onClick={() =>
                                navigate(
                                  `/customer-history/${
                                    WorkOrderDataList?.quoteWorkOrderCustomerId ||
                                    null
                                  }`
                                )
                              }
                            >
                              <VisibilitySharpIcon
                                className={classes.viewListIcon}
                              />
                            </Button> */}
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              className={classes.h5}
                              sx={{ flexGrow: 1, textAlign: "center" }}
                            >
                                                            {WorkOrderDataList?.customer?.customerCompanyName && (
    <Typography component="span">
      {WorkOrderDataList.customer.customerCompanyName}
    </Typography>
  )}

  {WorkOrderDataList?.customer?.customerCompanyPhoneNumebr && (
    <Typography component="span">
      {" / "}
      {WorkOrderDataList.customer.customerCompanyPhoneNumebr}
    </Typography>
  )}

  {WorkOrderDataList?.customer?.customerCompanyEmail && (
    <Typography component="span">
      {" / "}
      {WorkOrderDataList.customer.customerCompanyEmail}
    </Typography>
  )}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              className={classes.h5}
                              sx={{ flexGrow: 1, textAlign: "center" }}
                            >
                             {WorkOrderDataList?.customer?.customerMobileNum && (
    <Typography component="span">
      {WorkOrderDataList.customer.customerMobileNum}
    </Typography>
  )}

  {WorkOrderDataList?.customer?.customerEmail && (
    <Typography component="span">
      {" / "}
      {WorkOrderDataList.customer.customerEmail}
    </Typography>
  )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {invoiceList?.assign_driver && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
    <Card className={classes.stepperCard} sx={{ padding: 2, borderRadius: 3, boxShadow: 5 }}>
      <Grid container spacing={1} sx={{ padding: 1 }}>

        {/* Title: Driver Details */}
        <Grid item xs={12} sx={{ textAlign: "center", marginBottom: 1 }}>
          {/* <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Driver Details
          </Typography> */}
        </Grid>

        {/* Driver Details in Rows of 2 */}
        <Grid container spacing={2}>
          {invoiceList?.drivers?.map((driver: any, index: any) => {

    const assignedDrivers = invoiceList.assign_driver.assign_to 
   ? JSON.parse(invoiceList.assign_driver.assign_to) 
   : [];

// Find the assigned price and hourPrice for the driver
const driverAssignment = assignedDrivers.find((d: any) => d.driverId === driver.id);
const hasPrice = driverAssignment?.price && driverAssignment?.hourPrice; 
const isEditing = Boolean(driverAssignment?.price);

return (

            <Grid item xs={12} sm={6} key={index}> {/* Each driver takes up half of the row (xs=6) */}
              {/* <Card sx={{ padding: 2, borderRadius: 3, boxShadow: 3 }}> */}
                <Grid container spacing={2}>

                  {/* Driver's Image */}
                  <Grid item xs={4} sx={{ textAlign: "center" }}>
                    {driver.driverImg ? (
                      <img
                        src={`${LARAVEL_API_URL}/${driver.driverImg}`}
                        alt="Profile"
                        className={classes.SelectImageBox}
                        style={{
                          width: 70,
                          height: 70,
                          borderRadius: '10%',
                          border: '2px solid #ddd',
                          objectFit: 'cover',
                        }}
                      />
                    ) : (
                      <Avatar  alt="Profile"
                      sx={{ width: 70, height: 70, objectFit: 'cover',borderRadius: '10%',border: '2px solid #ddd' }} />
                    )}
                  </Grid>

                  {/* Driver's Info */}
                  <Grid item xs={8}>
                    <Typography
                      variant="h5"
                      sx={{
                        color: theme.palette.text.primary,
                        fontWeight: 'bold',
                        marginBottom: 0.5,
                        textAlign: "left",
                      }}
                    >
                   {`${driver.driverFirstName?.charAt(0).toUpperCase() + driver.driverFirstName?.slice(1).toLowerCase() || ""} 
${driver.driverLastName?.charAt(0).toUpperCase() + driver.driverLastName?.slice(1).toLowerCase() || ""}` || "Driver Name"}

                    </Typography>

                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: 0.5 }}>
                      <strong>Phone:</strong> {driver.driverMobileNum || "N/A"}
                    </Typography>

                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: 0.5 }}>
                      <strong>Email:</strong> {driver.driverEmail || "N/A"}
                    </Typography>

                   {hasPrice ? (
          <>
     <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: 0.5 }}>
              <strong>Trip Price:</strong> ${driverAssignment.price}
              <IconButton size="small" sx={{ marginLeft: 1 }}   onClick={() => handleOpenPriceDialog(driver.id)} >
    <EditSharpIcon className={classes.editListIcon}  sx={{ fontSize: 12 }}/>
  </IconButton>
            </Typography>

            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: 1 }}>
              <strong>Hourly Price:</strong> ${driverAssignment.hourPrice}/hr
           
            </Typography>
          </>
        ) : (
          <IconButton size="small" color="primary" style={{fontSize:'14px'}} sx={{ marginBottom: 1 }}
          onClick={() => handleOpenPriceDialog(driver.id)}

           >
            <AddIcon />Add Price
          </IconButton>
        )}

  <Dialog
  open={isPriceDialogOpen}
  onClose={handleClosePriceDialog}
  PaperProps={{
    className: classes.BgDialog, // Apply the class here
  }}
  maxWidth="sm"
  fullWidth
>
<DialogTitle>
{isEditing ? "Edit Price Details" : "Enter Price Details"}
    <IconButton
      aria-label="close"
      onClick={handleClosePriceDialog}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CancelOutlined className={classes.CancelOutlined} />
    </IconButton>
  </DialogTitle>
  <DialogContent>


  <Grid container spacing={1} p={"14px"}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">Driver</Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              className={classes.textField}
              InputProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              value={selectedDriverName}
             disabled
            />
          </Grid>
        </Grid>
      </Grid>
  
             
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">Price</Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
    <TextField
     className={classes.textField}
     InputProps={{
    inputProps: { min: 0 }, 
  }}
     variant="outlined"
     size="small"
      type="number"
      fullWidth
      value={tripPrice}
      onChange={(e) => setTripPrice(e.target.value)}
    />
    </Grid>
    </Grid>
    </Grid>

    <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">Hour Price</Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
    <TextField
      size="small"
       variant="outlined"
      type="number"
      InputProps={{
        inputProps: { min: 0 }, 
      }}
      fullWidth
      value={hourPrice}
      onChange={(e) => setHourPrice(e.target.value)}
    />
  </Grid>
    </Grid>
    </Grid>

</Grid>
  </DialogContent>
  <DialogActions>
    <DialogActions>
    <Grid item lg={12} md={12} sm={12} xs={12} >
     
        <Grid container p={"24px"}>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              disabled={loading}
              className={classes.addButton}
              onClick={handleSavePrice}
              variant="contained"
            >
                {loading ? <CircularProgress size={24} /> : isEditing ? "Update" : "Save"}
            </Button>
          </Grid>
        </Grid>
     
    </Grid>
  </DialogActions>

  </DialogActions>
</Dialog>



                    {/* Buttons */}
                      <Grid container spacing={1} sx={{ justifyContent: "flex-start" }}>
                        <Grid item>

                        

                          <Button   disabled={loadingStates[driver.id] || false} 
                            variant="contained"
                            color="primary"
                            className={classes.addButton}
                            onClick={() => handleOpenDriverDialog(driver)}  
                            sx={{
                              fontSize: '0.75rem',
                              padding: '4px 10px',
                              minWidth: 'auto',
                              textTransform: 'none',
                            }}
                          >
                              {loadingStates[driver.id] ? <CircularProgress size={24} /> : "Send by Email"}
                        
                          </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.addButton}
                          sx={{
                            fontSize: '0.75rem',
                            padding: '4px 10px',
                            minWidth: 'auto',
                            textTransform: 'none',
                          }}
                        >
                          Send a Text
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>

                </Grid>
              {/* </Card> */}
            </Grid>
           );
          })}
        </Grid>

      </Grid>
    </Card>
  </Grid>
)}









                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Services
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} pb={5}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TableContainer>
                          <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                     <TableRow>
                       {/* <TableCell className={classes.tablheader}>
                        <strong>#</strong>
                      </TableCell> */}
                       {/* <TableCell className={classes.tablheader}>
                        <strong>Bus & Services Information</strong>
                         </TableCell> */}
                                                                   
                                                                     <TableCell className={classes.tablheader}>
                                                                   <strong>Trip Information</strong>
                                                                       </TableCell>
                                                                      {/* <TableCell
                                                                        className={classes.tablheader}
                                                                        sx={{ textAlign: "right" }}
                                                                      >
                                                                        <strong>Quantity</strong>
                                                                      </TableCell> */}
                                                                      <TableCell
                                                                        className={classes.tablheader}
                                                                        sx={{ textAlign: "right" }}
                                                                      >
                                                                        <strong>Price</strong>
                                                                      </TableCell>
                                                                      {/* <TableCell
                                                                        className={classes.tablheader}
                                                                        sx={{ textAlign: "right" }}
                                                                      >
                                                                        <strong>Tax</strong>
                                                                      
                                                                      </TableCell> */}
                                                                      {/* <TableCell
                                                                        className={classes.tablheader}
                                                                        sx={{ textAlign: "right" }}
                                                                      >
                                                                        <strong>Price</strong>
                                                                      </TableCell> */}
                                                                      {/* <TableCell
                                                                        className={classes.tablheader}
                                                                        sx={{ textAlign: "right" }}
                                                                      >
                                                                        <strong>Total</strong>
                                                                      </TableCell> */}
                                                                    </TableRow>
                                                                  </TableHead>
                                                                  <TableBody>
                                                                    {workOrderError || coursings.length === 0 ? (
                                                                      <TableRow>
                                                                        <TableCell colSpan={8} align="center">
                                                                          {workOrderError
                                                                            ? "Error fetching data"
                                                                            : "No data available"}
                                                                        </TableCell>
                                                                      </TableRow>
                                                                    ) : (
                                                                      (invoiceCoursings.length > 0 ? invoiceCoursings : coursings)

                                                                        .slice(
                                                                          page * rowsPerPage,
                                                                          page * rowsPerPage + rowsPerPage
                                                                        )
                                                                        .map((product: any, index: any) => (
                                                                          <TableRow
                                                                            key={index}
                                                                            className={classes.tableRowHover}
                                                                          >
                                                                            {/* <TableCell className={classes.tablCell}>
                                                                            {page * rowsPerPage + index + 1}
                                                                          </TableCell> */}
                                                                            {/* <TableCell className={classes.tablCell}>
                                                                              {!isMobile ? (
                                                                                <Grid container spacing={1}>
                                                                                  <Grid
                                                                                    item
                                                                                    sm={10}
                                                                                    xs={12}
                                                                                    textAlign={"left"}
                                                                                    alignContent={"center"}
                                                                                  >
                                                                                    <Typography>
                                                                                      <strong>
                                                                                        {product.productName}
                                                                                      </strong>
                                                                                    </Typography>
                                                                                  </Grid>
                                                                                </Grid>
                                                                              ) : (
                                                                                <Grid container spacing={1}>
                                                                                  <Grid item sm={10} xs={12} textAlign={"left"} alignContent={"center"}
                                                                                  >
                                                                                    <Typography>
                                                                                      <strong>
                                                                                        {product.productName}
                                                                                      </strong>
                                                                                    </Typography>
                                                                                  </Grid>
                                                                                </Grid>
                                                                              )}
                                        
                                                                              <Typography variant="body2" color="textSecondary">
                                                                                      {product.productDescription || ""}
                                                                                    </Typography>
                                                                                    <Typography variant="body2">
                                                                                     {product.numberOfPassengers && `${product.numberOfPassengers} Passengers`} 
                                                                                     {product.numberOfPassengers && product.busCount ? " | " : ""}
                                                                                     {product.busCount && `${product.busCount} bus`}
                                                                                   </Typography>
                                                                            </TableCell> */}
                                                                           
                                                                         
                                                                            
{/*                          
                                                                                    <TableCell
                                                                                     component="th"
                                                                                    scope="row"
                                                                                    className={classes.tablCell} >
                                                                                    
                                                                                    <Typography variant="body2" >
                                                                                    
                                                                                    <Typography variant="subtitle1" component="div" gutterBottom>
                                                                                      {product.transferType
                                                                                        ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
                                                                                            .find((key) => TransferType[key] === String(product.transferType))
                                                                                        : ""}
                                                                                      {product.transferTypeFrom && product.transferTypeTo ? ` (${product.transferTypeFrom} to ${product.transferTypeTo})` : ""}
                                                                                    </Typography>
                                                                                     </Typography>
                                                                                     {product.departureAddress && product.departureDateTime && (
                           <Typography variant="body2" component="div" gutterBottom>
                             <>
                               <strong>Departure:</strong> {product.departureAddress}<br /> (
                               {dayjs(product.departureDateTime).isValid()
                                 ? dayjs(product.departureDateTime).format("DD-MMM-YY hh:mm A")
                                 : product.departureDateTime}
                               )
                             </>
                           </Typography>
                         )}
                         
                                                                               
                         {product.destinationAddress && (
  <Typography variant="body2" component="div" gutterBottom>
    <>
      <strong>Destination:</strong> {product.destinationAddress}
      {product.returnDateTime && dayjs(product.returnDateTime).isValid() && (
        <>
          <br /> ({dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")})
        </>
      )}
    </>
  </Typography>
)}

                                                                                                            
                                                                                                              </TableCell> */}
                         <TableCell component="th" scope="row" className={classes.tablCell}>
                           <Typography variant="body2">
                             <Typography variant="subtitle1" component="div" gutterBottom>
                               {product.transferType
                                 ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find(
                                     (key) => TransferType[key] === String(product.transferType)
                                   )
                                 : ""}
                               {product.transferTypeFrom && product.transferTypeTo
                                 ? ` (${product.transferTypeFrom} to ${product.transferTypeTo})`
                                 : ""}
                             </Typography>
                           </Typography>
                         
                           {/* Pickup Locations */}
                         {(product.pickups || [])
                           .filter((pickup : any)=> pickup.address || pickup.city)
                           .map((pickup: any, index: any, arr: any) => (
                             <Typography key={index} variant="body2" component="div" gutterBottom>
                           <strong>
                             Pickup{arr.length > 1 ? ` ${index + 1}` : ""}:
                           </strong>{" "}
                           {pickup.address}
                           {/* {pickup.address && pickup.city ? ", " : ""}
                           {pickup.city} */}
                           {pickup.dateTime && dayjs(pickup.dateTime).isValid() && (
                             <>
                               <br />({dayjs(pickup.dateTime).format("DD-MMM-YY hh:mm A")})
                             </>
                           )}
                         </Typography>
                           ))}
                         
                         {/* Dropoff Locations */}
                         {(product.dropoffs || [])
                           .filter((drop: any) => drop.address || drop.city)
                           .map((drop: any, index: any, arr: any) => (
                             <Typography key={index} variant="body2" component="div" gutterBottom>
                               <strong>
                                 Dropoff{arr.length > 1 ? ` ${index + 1}` : ""}:
                               </strong>{" "}
                               {drop.address}
                               {/* {drop.address && drop.city ? ", " : ""}
                               {drop.city} */}
                               {drop.dateTime && dayjs(drop.dateTime).isValid() && (
                                 <>
                                   <br />({dayjs(drop.dateTime).format("DD-MMM-YY hh:mm A")})
                                 </>
                               )}
                             </Typography>
                           ))}
                         
                         {/* Return Pickups */}
                         {(product.returnPickups || [])
                           .filter((pickup: any) => pickup.address || pickup.city)
                           .map((pickup: any, index: any, arr: any) => (
                             <Typography key={index} variant="body2" component="div" gutterBottom>
                               <strong>
                                 Return Pickup{arr.length > 1 ? ` ${index + 1}` : ""}:
                               </strong>{" "}
                               {pickup.address}
                               {/* {pickup.address && pickup.city ? ", " : ""}
                               {pickup.city} */}
                               {pickup.dateTime && dayjs(pickup.dateTime).isValid() && (
                                 <>
                                   <br />({dayjs(pickup.dateTime).format("DD-MMM-YY hh:mm A")})
                                 </>
                               )}
                             </Typography>
                           ))}
                         
                         {/* Return Dropoffs */}
                         {(product.returnDropoffs || [])
                           .filter((drop: any) => drop.address || drop.city)
                           .map((drop: any, index: any, arr: any) => (
                             <Typography key={index} variant="body2" component="div" gutterBottom>
                               <strong>
                                 Return Dropoff{arr.length > 1 ? ` ${index + 1}` : ""}:
                               </strong>{" "}
                               {drop.address}
                               {/* {drop.address && drop.city ? ", " : ""}
                               {drop.city} */}
                               {drop.dateTime && dayjs(drop.dateTime).isValid() && (
                                 <>
                                   <br />({dayjs(drop.dateTime).format("DD-MMM-YY hh:mm A")})
                                 </>
                               )}
                             </Typography>
                           ))}
                         </TableCell>
                                                                            {/* <TableCell
                                                                              className={classes.tablCell}
                                                                              align="right"
                                                                            >
                                                                              {product.quantity}
                                                                            </TableCell> */}
                                                                            <TableCell
                                                                              className={classes.tablCell}
                                                                              align="right"
                                                                            >
                                                                              {(product.price ?? 0).toFixed(2)}
                                                                            </TableCell>
                                                                            {/* <TableCell
                                                                              className={classes.tablCell}
                                                                              align="right"
                                                                            >
                                                                              {(product.taxAmount && !isNaN(product.taxAmount) ? product.taxAmount.toFixed(2) : "0.00")}
                                                                            </TableCell> */}
                                                                            {/* <TableCell
                                                                              className={classes.tablCell}
                                                                              align="right"
                                                                            >
                                                                              {(
                                                                                product.unitPriceWithDiscount ?? 0
                                                                              ).toFixed(2)}
                                                                            </TableCell> */}
                                                                            {/* <TableCell
                                                                              className={classes.tablCell}
                                                                              align="right"
                                                                            >
                                                                              {product.unitTotalWithDiscount != null
                                                                                ? product.unitTotalWithDiscount.toFixed(
                                                                                    2
                                                                                  )
                                                                                : "0.00"}
                                                                            </TableCell> */}
                                                                          </TableRow>
                                                                        ))
                                                                    )}
                                                                  </TableBody>
                                                                </Table>
                                                              </TableContainer>
                                                            </Grid>
                         
                         
                         

   <Box display="flex" justifyContent="flex-end" width="100%" marginTop={3} padding={2}>
  <Box width="200px" ml="auto">
    {/* Using Grid container with proper spacing and justifyContent for alignment */}
    <Grid container spacing={1}>

    <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                <Typography sx={{ whiteSpace: "nowrap" }}>
                  Sub Total:
                </Typography>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
            <Typography >
              ${invoiceList ? invoiceTotalPrice.toFixed(2) : totalPrice.toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>


      {(invoiceDiscountList.length > 0 ? invoiceDiscountList : discountList)
        .map((discount: any, index: any) => (
          <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                      <Typography>
                      {discount.description || "Discount"}
                      {":"}
           {/* Discount {discount.description ? `(${discount.description})` : "Discount"}: */}
         </Typography>

              </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                <Typography>
                  {"$"}
                  {(discount.value !== null ? discount.value : 0).toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}

    {((invoiceList?.quoteWorkOrderDiscount && parseFloat(invoiceList.quoteWorkOrderDiscount) !== 0) || 
  (WorkOrderDataList?.quoteWorkOrderDiscount && parseFloat(WorkOrderDataList.quoteWorkOrderDiscount) !== 0)) && (
      
          <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                        <Typography sx={{ whiteSpace: "nowrap" }}>
                Total Discount:
              </Typography>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                         <Typography sx={{ whiteSpace: "nowrap" }}>
                {"$"}
                {parseFloat(
                  invoiceList
                    ? invoiceList?.quoteWorkOrderDiscount || "0"
                    : WorkOrderDataList?.quoteWorkOrderDiscount || "0"
                ).toFixed(2)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

    



   
         <Grid item lg={12} md={12} sm={12} xs={12}>
           <Grid container spacing={2}>
             <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
               <Typography sx={{ whiteSpace: "nowrap" }}>HST:</Typography>
             </Grid>
             <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
            <Typography>
              ${invoiceList ? invoiceTotalTax.toFixed(2) : totalTax.toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                  <Typography sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    Grand Total:
                  </Typography>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                  <Typography style={{ fontWeight: "bold" }}>
              ${parseFloat(
                invoiceList
                  ? invoiceList?.quoteWorkOrderSaleGrandTotal || "0"
                  : WorkOrderDataList?.quoteWorkOrderSaleGrandTotal || "0"
              ).toFixed(2)}
                 
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Settled Amount */}
     <Grid item lg={12} md={12} sm={12} xs={12}>
             <Grid container spacing={2}>
               <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                 <Typography sx={{ whiteSpace: "nowrap"}}>
                 Settled Amount:
                 </Typography>
               </Grid>
               <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                 <Typography >
                 ${amountPaid}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

    <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                <Typography sx={{ whiteSpace: "nowrap"}}>
               Balance Amount:
                </Typography>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                <Typography >
                ${(
  Math.max(0, parseFloat(invoiceList?.quoteWorkOrderSaleGrandTotal ?? "0") - (amountPaid ?? 0))
).toFixed(2)}

            </Typography>
          </Grid>
        </Grid>
      </Grid>

      
    </Grid>
  </Box>
</Box>



                    </Grid>
                  </Card>

                </Grid>


                {Array.isArray(invoiceHistories) && invoiceHistories.length > 0 && (
                   <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Invoice History 
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} pb={5}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>

                  


  <Grid container justifyContent={"space-between"} spacing={5} sx={{ borderBottom: 2, padding: 2 }} className={classes.titleGrid}>
    <Grid item lg={12} md={12} sm={12} xs={12} pt={2} alignContent={"center"} className={classes.titleGrid}>
      <Stepper orientation="vertical" activeStep={invoiceHistories.length}>
        {invoiceHistories.map((invoiceHistory, index) => {
          // Filter for created invoice (index === 0) or edited ones
          const isCreated = index === 0; // Modify this logic to reflect the correct step state

          return (
            <Step key={index}>
              <StepLabel>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography className={classes.h5}>
                    {isCreated ? (
                      <Typography variant="body1">
                        <strong>Invoice Created</strong>
                      </Typography>
                    ) : (
                      <Typography variant="body1">
                        <strong>Invoice Edited</strong>
                      </Typography>
                    )}
                  </Typography>
                  <Button
                    variant="contained"
                    className={classes.editButtonList}
                    onClick={() => toggleStepInvoice(index)}
                  >
                    {expandedStepsInvoice.includes(index) ? (
                      <ExpandLessSharpIcon className={classes.editListIcon} />
                    ) : (
                      <ExpandMoreSharpIcon className={classes.editListIcon} />
                    )}
                  </Button>
                </Box>
              </StepLabel>
              {expandedStepsInvoice.includes(index) && (
                <>
                  <Box sx={{ ml: 4, mt: 1 }}>
                    <Typography variant="body1">
                      {isCreated ? <strong>Created by</strong> : <strong>Edited by</strong>}: {invoiceHistory.updated_by}
                    </Typography>
                    <Typography variant="body2">
                      {isCreated ? <strong>Created at</strong> : <strong>Edited at</strong>}: {dayjs(isCreated ? invoiceHistory.created_at : invoiceHistory.updated_at).format("MMM D, YYYY [at] h:mm A")}
                    </Typography>
                    {invoiceHistory.po_number && (
  <Typography variant="body2">
    <strong>PO Number:</strong> {String(invoiceHistory.po_number)}
  </Typography>
)}

                  </Box>
                  <TableContainer>
                    <Box sx={{ ml: 4, mt: 1 }}>
                      {Array.isArray(invoiceHistory.quoteWorkOrderSale) && invoiceHistory.quoteWorkOrderSale.length > 0 ? (
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell className={classes.tablheader}>
                                <strong>Bus & Services Information</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Trip Information</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader} sx={{ textAlign: "right" }}>
                                <strong>Price</strong>
                              </TableCell>
                              {/* <TableCell className={classes.tablheader} sx={{ textAlign: "right" }}>
                                <strong>Tax</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader} sx={{ textAlign: "right" }}>
                                <strong>Total</strong>
                              </TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoiceHistory.quoteWorkOrderSale.map((product: any, index: any) => (
                              <TableRow key={index} className={classes.tableRowHover}>
                                <TableCell className={classes.tablCell}>
                                  <Typography variant="body1">
                                    <strong>{product.productName}</strong>
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary">
                                    {product.productDescription || ""}
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary">
                                    {product.numberOfPassengers && `${product.numberOfPassengers} Passengers`}
                                    {product.numberOfPassengers && product.busCount ? " | " : ""}
                                    {product.busCount && `${product.busCount} bus`}
                                  </Typography>
                                </TableCell>

                                <TableCell component="th" scope="row" className={classes.tablCell}>
  <Typography variant="body2">
    <Typography variant="subtitle1" component="div" gutterBottom>
      {product.transferType
        ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
            .find((key) => TransferType[key] === String(product.transferType))
        : ""}
      {product.transferTypeFrom && product.transferTypeTo
        ? ` (${product.transferTypeFrom} to ${product.transferTypeTo})`
        : ""}
    </Typography>
  </Typography>

  {product.departureAddress && product.departureDateTime && (
    <Typography variant="body2" component="div" gutterBottom>
      <>
        <strong>Departure:</strong> {product.departureAddress}
        <br />
        (
        {dayjs(product.departureDateTime).isValid()
          ? dayjs(product.departureDateTime).format("DD-MMM-YY hh:mm A")
          : product.departureDateTime}
        )
      </>
    </Typography>
  )}

   {product.destinationAddress && (
  <Typography variant="body2" component="div" gutterBottom>
    <>
      <strong>Destination:</strong> {product.destinationAddress}
      {product.returnDateTime && dayjs(product.returnDateTime).isValid() && (
        <>
          <br /> ({dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")})
        </>
      )}
    </>
  </Typography>
)}
</TableCell>


                                <TableCell className={classes.tablCell} align="right">
                                  {(product.price ?? 0).toFixed(2)}
                                </TableCell>
                                {/* <TableCell className={classes.tablCell} align="right">
                                  {(product.taxAmount && !isNaN(product.taxAmount) ? product.taxAmount.toFixed(2) : "0.00")}
                                </TableCell>
                                <TableCell className={classes.tablCell} align="right">
                                  {product.unitTotalWithDiscount != null ? product.unitTotalWithDiscount.toFixed(2) : "0.00"}
                                </TableCell> */}
                              </TableRow>
                            ))}

{invoiceHistory.quoteWorkOrderSaleDiscountDescription &&
                    invoiceHistory.quoteWorkOrderSaleDiscountDescription.length > 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="right" style={{ paddingBottom: '0px' }}>
                        {invoiceHistory.quoteWorkOrderSaleDiscountDescription.map((discount: any, discountIndex: any) => (
                          <Grid container key={discountIndex} spacing={1} justifyContent="flex-end">
                            <Grid item lg={2} md={2} sm={6} xs={8} textAlign="end">
                              <Typography variant="body2">
                                {discount.description || "Discount"}:
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={2} sm={2} xs={4} textAlign="end">
                              <Typography variant="body2">
                                {"$"}{(discount.value !== null ? discount.value : 0).toFixed(2)}
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </TableCell>
                    </TableRow>
                  ) : null}

{invoiceHistory.quoteWorkOrderDiscount && parseFloat(invoiceHistory.quoteWorkOrderDiscount) > 0 && (
                                    <TableRow>
                                      <TableCell colSpan={6} align="right" style={{ paddingBottom: '0px' }}>
                                        <Grid container spacing={1} justifyContent="flex-end">
                                          <Grid item lg={3} md={3} sm={6} xs={8} textAlign="end">
                                            <Typography variant="body2" sx={{ whiteSpace: "nowrap", fontWeight: "normal" }}>
                                              Total Discount:
                                            </Typography>
                                          </Grid>
                                          <Grid item lg={2} md={2} sm={2} xs={4} textAlign="end">
                                            <Typography variant="body2">
                                              {"$"}{parseFloat(invoiceHistory.quoteWorkOrderDiscount || "0").toFixed(2)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  )}





                                  {invoiceHistory.quoteWorkOrderSaleGrandTotal &&
                                    invoiceHistory.quoteWorkOrderSaleGrandTotal.length > 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={6} align="right">
                                        <Grid container spacing={1} justifyContent="flex-end">
                                          <Grid item lg={3} md={3} sm={6} xs={8} textAlign="end">
                                            <Typography variant="body2" sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                                              Grand Total:
                                            </Typography>
                                          </Grid>
                                          <Grid item lg={2} md={2} sm={2} xs={4} textAlign="end">
                                            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                              {"$"}{parseFloat(invoiceHistory.quoteWorkOrderSaleGrandTotal || "0").toFixed(2)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={6} align="right">
                                        <Typography variant="body2" color="textSecondary">
                                          No data
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  )}

                          </TableBody>
                        </Table>
                      ) : (
                        <Table>
                          <TableRow>
                            <TableCell colSpan={8} align="center">
                              No data available
                            </TableCell>
                          </TableRow>
                        </Table>
                      )}
                    </Box>
                  </TableContainer>
                </>
              )}
            </Step>
          );
        })}
      </Stepper>
    </Grid>
  </Grid>





                            </Grid>
   
                            </Grid>
</Card>
</Grid>
)}


               


              </Grid>
            </Grid>
            
      
          <Grid item lg={4} md={4} sm={12} xs={12} >
       

  <Grid container spacing={3} >
    {/* Payment Details */}
    
    { dueAmount > 0 &&  (
      
    <Grid item lg={12} md={12} sm={12} xs={12} >
      <Card className={classes.stepperCard}
         sx={{ backgroundColor: (theme) => `${alpha(theme.palette.primary.light, 0.1)} !important` }} >

      {workOrderHistoryData && Array.isArray(workOrderHistoryData.data) && workOrderHistoryData.data.length > 0 ? (
  workOrderHistoryData.data.map((order, index) => (
    order.InvoiceNo ? (
        <><Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          pt={2}
          alignContent={"center"} 
        >
          {/* <Typography className={classes.cardTitle}>
            Invoice No: {order.InvoiceNo}
          </Typography> */}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="h5" >Invoice No: {order.InvoiceNo}</Typography>
          </Grid>

        </Grid>
      </Grid>
      
        <Grid container spacing={2} sx={{ padding: 2 }} key={index}>
          {/* Invoice No Section */}
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <Typography variant="body1">Total Due</Typography>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography variant="body1" textAlign="left"> {"$"}
  
   {/* {Number(invoiceList?.due_amount || 0
  ).toFixed(2)} */}

{/* {parseFloat(invoiceList?.quoteWorkOrderSaleGrandTotal ?? "0").toFixed(2)} */}
 {(parseFloat(invoiceList?.quoteWorkOrderSaleGrandTotal ?? "0") - (amountPaid ?? 0)).toFixed(2)}



         </Typography>
          </Grid>

          {/* Amount Section */}
          <Grid item lg={8} md={8} sm={12} xs={12}>
    <Typography variant="body1">{amountPaid <= 0 ? 'Generate Payment Link (100%)' : 'Generate Payment Link'}</Typography>
  </Grid>
  {/* <Grid item lg={4} md={4} sm={12} xs={12} textAlign="left">
    <Typography variant="body1">
      {"$"}
      {(
        (Number(order.quoteWorkOrderSaleGrandTotal || 0) * 0.3)
      ).toFixed(2)}
    </Typography>
  </Grid> */}
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextField
              value={editableAmount}
              onChange={handleAmountChange}
              variant="outlined"
              size="small"
              fullWidth
              className={classes.textField}
              InputProps={{
                sx: {
                  fontSize: 14,
                },
                startAdornment: <Typography variant="h6">$</Typography>,
              }}
              InputLabelProps={{
                sx: {
                  fontSize: 14,
                },
              }} />
          </Grid>

          {/* Action Button */}
          <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="right" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                className={classes.addButton}
               onClick={handleSendPaymentLink} 
               sx={{
                fontSize: '0.75rem', // Smaller font size
                padding: '4px 8px',  // Reduced padding for a smaller button
                minWidth: 'auto',    // Allows the button width to shrink to fit content
                textTransform: 'none', // Keeps the text case as-is
              }}
              >
                Send by email
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                className={classes.addButton}
                sx={{
                  fontSize: '0.75rem', // Smaller font size
                  padding: '4px 8px',  // Reduced padding for a smaller button
                  minWidth: 'auto',    // Allows the button width to shrink to fit content
                  textTransform: 'none', // Keeps the text case as-is
                }}
              >
                Send a text
              </Button>
            </Grid>
          </Grid>



        </Grid></>
    ) : null // Don't render anything if InvoiceNo is null or undefined
  ))
) : (
  <Typography sx={{ padding: 2 }} variant="body1" color="textSecondary">
    No payment history available.
  </Typography>
)}
      </Card>
    </Grid>
    )}




<Dialog open={showDriverEmailDialog} onClose={handleDriverEmailDialogClose}  
     PaperProps={{
      className: classes.BgDialog,  // Apply the class here
    }}
    maxWidth="md" fullWidth >
     <DialogTitle>Send Email
     <IconButton
 aria-label="close"
 onClick={handleDriverEmailDialogClose}
 sx={{
   position: 'absolute',
   right: 8,
   top: 8,
   color: (theme) => theme.palette.grey[500],
 }}
>
 <CancelOutlined className={classes.CancelOutlined}/>
</IconButton>
     </DialogTitle>
     <DialogContent>
          <Grid container spacing={1} p={"14px"}>
         <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    To
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
         size="small"
         className={classes.textField}
         InputProps={{
           sx: {
             fontSize: 14,
           },
         }}
         InputLabelProps={{
           sx: {
             fontSize: 14,
           },
           shrink: true, 
         }}
         value={driverEmailData.to}
         onChange={(e) => setDriverEmailData({ ...driverEmailData, to: e.target.value })}
       />
         </Grid>
                             </Grid>
                           </Grid>
                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    Select Template
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                               <TextField
  size="small"
  rows={4}
  className={classes.textField}
  select
  value={driverEmailData.template}  // Controlled by state
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...driverEmailData,
      template: selectedTemplateId, // Update selected template
      subject: driverEmailData.subject, // Reset subject and message when template changes
      message: driverEmailData.message,
    });
  }}

    >
    <MenuItem value="">
    Select option
    </MenuItem>
    {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
     {template.template_name} {/* Display the name of the template */}
    </MenuItem>
    ))}
    </TextField>
</Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                   Subject
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
        size="small"
        className={classes.textField}
        InputProps={{
          sx: {
            fontSize: 14,
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: 14,
          },
        }}
         value={driverEmailData.subject}
         onChange={(e) => setDriverEmailData({ ...driverEmailData, subject: e.target.value })}
       />
       </Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    {/* Message Label */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Message</Typography>
    </Grid>

    {/* ReactQuill Editor */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <ReactQuill
        value={driverEmailData.message} // Bind only the message value
        onChange={(value) =>
          setDriverEmailData({ ...driverEmailData, message: value })
        } // Update message value in the state
        style={{
          height: "210px",
        }}
      />


    </Grid>
  </Grid>
</Grid>

{/* Attachments Section */}
<Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
    
    </Grid>
  </Grid>
</Grid>


       
       </Grid>
     </DialogContent>
     <DialogActions>



     <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
           <Card className={classes.card}>
             <Grid container spacing={3} p={"24px"}>
               <Grid
                 item
                 lg={12}
                 md={12}
                 sm={12}
                 xs={12}
                 sx={{ display: "flex", justifyContent: "flex-end" }}
               >
               
       <Button   disabled={loading}   startIcon={<SaveAltIcon />} 
     className={classes.addButton} onClick={handleReSendDriverEmail} variant="contained">
       {loading ? <CircularProgress size={24} /> : "Send"}
       </Button>
       </Grid>
       </Grid>
       </Card>
       </Grid>
     </DialogActions>
   </Dialog>



   <Dialog open={showEmailDialog} onClose={handleEmailDialogClose}  
     PaperProps={{
      className: classes.BgDialog,  // Apply the class here
    }}
    maxWidth="md" fullWidth >
     <DialogTitle>Send Email
     <IconButton
 aria-label="close"
 onClick={handleEmailDialogClose}
 sx={{
   position: 'absolute',
   right: 8,
   top: 8,
   color: (theme) => theme.palette.grey[500],
 }}
>
 <CancelOutlined className={classes.CancelOutlined}/>
</IconButton>
     </DialogTitle>
     <DialogContent>
          <Grid container spacing={1} p={"14px"}>
         <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    To
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
         size="small"
         className={classes.textField}
         InputProps={{
           sx: {
             fontSize: 14,
           },
         }}
         InputLabelProps={{
           sx: {
             fontSize: 14,
           },
           shrink: true, 
         }}
         value={invoiceEmailData.to}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
       />
         </Grid>
                             </Grid>
                           </Grid>
                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    Select Template
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                               <TextField
  size="small"
  rows={4}
  className={classes.textField}
  select
  value={invoiceEmailData.template}  // Controlled by state
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...invoiceEmailData,
      template: selectedTemplateId, // Update selected template
      subject: invoiceEmailData.subject, // Reset subject and message when template changes
      message: invoiceEmailData.message,
    });
  }}

    >
    <MenuItem value="">
    Select option
    </MenuItem>
    {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
     {template.template_name} {/* Display the name of the template */}
    </MenuItem>
    ))}
    </TextField>
</Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={6} md={6} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                   Subject
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
        size="small"
        className={classes.textField}
        InputProps={{
          sx: {
            fontSize: 14,
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: 14,
          },
        }}
         value={invoiceEmailData.subject}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
       />
       </Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    {/* Message Label */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Message</Typography>
    </Grid>

    {/* ReactQuill Editor */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <ReactQuill
        value={invoiceEmailData.message} // Bind only the message value
        onChange={(value) =>
          setInvoiceEmailData({ ...invoiceEmailData, message: value })
        } // Update message value in the state
        style={{
          height: "210px",
        }}
      />


    </Grid>
  </Grid>
</Grid>

{/* Attachments Section */}
<Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
    
    </Grid>
  </Grid>
</Grid>


       
       </Grid>
     </DialogContent>
     <DialogActions>



     <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
           <Card className={classes.card}>
             <Grid container spacing={3} p={"24px"}>
               <Grid
                 item
                 lg={12}
                 md={12}
                 sm={12}
                 xs={12}
                 sx={{ display: "flex", justifyContent: "flex-end" }}
               >
               
       <Button   disabled={loading}   startIcon={<SaveAltIcon />} 
     className={classes.addButton} onClick={handleSendEmail} variant="contained">
       {loading ? <CircularProgress size={24} /> : "Send"}
       </Button>
       </Grid>
       </Grid>
       </Card>
       </Grid>
     </DialogActions>
   </Dialog>



    <Dialog open={showDriverDialog} onClose={handleDriverDialogClose}  
    PaperProps={{
      className: classes.BgDialog,  // Apply the class here
    }}
    maxWidth="md" fullWidth>
    <DialogTitle>
      Assign Driver
      <IconButton
        aria-label="close"
        onClick={handleDriverDialogClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CancelOutlined className={classes.CancelOutlined} />
      </IconButton>
    </DialogTitle>
    <DialogContent>

      
      <Grid container spacing={3}>
    
        {/* Left Side: Invoice/Work Order Details */}
        <Grid item lg={6} md={6} sm={12} xs={12} >
    <Typography variant="subtitle1">Available Drivers</Typography>
    {driverList.length > 0 ? (
      <Card elevation={3} >
        <CardContent>
          <Grid container spacing={2}  sx={{
          maxHeight: 250, // Fixed height for the table
          overflowY: 'auto', // Enables vertical scrolling
        }} >
    {availableDrivers.filter((driver) => driver.driverUserRole === 'driver').length > 0 ? (
            availableDrivers
            .filter((driver) => driver.driverUserRole === 'driver') 
            .map((driver) => (
              <Grid
                    item
                    xs={12}
                    container
                    alignItems="center"
                    spacing={2}
                    key={driver.id}
                  >
            
              {/* Checkbox for each driver */}
             

                {/* Driver Image */}
                <Grid item>
                  {driver.driverImg ? (
                    <img
                      src={`${LARAVEL_API_URL}/${driver.driverImg}`}
                      alt="Driver"
                      style={{
                        width: "30px",  // Make image smaller
                        height: "30px", // Make image smaller
                        borderRadius: "50%",
                        marginRight: "8px",
                      }}
                    />
                  ) : (
                    <Avatar
                      sx={{ width: 30, height: 30 }}  // Make avatar smaller
                      alt={`${driver.driverFirstName} ${driver.driverLastName}`}
                    />
                  )}
                </Grid>

                {/* Driver Name */}
                <Grid item>
                  <Typography variant="subtitle2" sx={{ fontSize: '0.875rem' }}>
                    {driver.driverFirstName} {driver.driverLastName}
                  </Typography>
                </Grid>

                {/* Assign Button */}



              
                <Grid item sx={{ ml: 'auto' }}>  
                {selectedDrivers.find((d) => d.id === driver.id) && (
  <>
    <TextField
      size="small"
      label="Price"
      type="number"
      InputProps={{
        inputProps: { min: 0 }, 
      }}
      value={selectedDrivers.find((d) => d.id === driver.id)?.price || ""}
      onChange={(e) => handleInputChange(driver.id, "price", Number(e.target.value))}
      sx={{ ml: 2, width: 100 }}
    />
    <TextField
      size="small"
      label="Hour Price"
      type="number"
      InputProps={{
        inputProps: { min: 0 }, 
      }}
      value={selectedDrivers.find((d) => d.id === driver.id)?.hourPrice || ""}
      onChange={(e) => handleInputChange(driver.id, "hourPrice", Number(e.target.value))}
      sx={{ ml: 2, width: 100 }}
    />
  </>
)}


         

<Checkbox
  size="small"
  checked={selectedDrivers.some((d) => d.id === driver.id)} 
  onChange={() => handleSelectDriver(driver.id)}
  
  disabled={
    selectedDrivers.length >= (invoiceList?.quoteWorkOrderSale?.[0]?.busCount || 0) &&
    !selectedDrivers.some((d) => d.id === driver.id) 
  }
/>

           
      {/* <Button
        size="small"  // Small button size
        variant="contained"
        className={classes.addButton}
        sx={{
          fontSize: '0.65rem', // Smaller font size
          padding: '4px 8px',  // Reduced padding for a smaller button
          minWidth: 'auto',    // Allows the button width to shrink to fit content
          textTransform: 'none', // Keeps the text case as-is
        }}
        onClick={() => handleAssignDriver(driver.id)}
      >
        Assign
      </Button>  */}
    </Grid>
              </Grid>
            ))
          ) : (
            <Typography
    variant="body2"
    sx={{
      textAlign: 'center',
      width: '100%',
      mt: 2, // Top margin
      mb: 2, // Bottom margin
  
    }}
  >
    No drivers available
  </Typography>

          )}
          
          </Grid>


  <Grid item>
  {nonAvailableDrivers.length > 0 && (
    <Button
      variant="text"
      size="small"
      sx={{
        fontSize: '0.75rem',
        padding: '4px 0px',
        minWidth: 'auto',
        textTransform: 'none',
      }}
      onClick={handleShowMore}
    >
      {showAllDrivers ? 'Show less' : 'Show more'}
    </Button>
  )}
          </Grid>
          {showAllDrivers && nonAvailableDrivers.length > 0 && (
        <>
          <Typography variant="subtitle1" sx={{ mt: 2, mb: 2 }}>
          Unavailable drivers
      </Typography>
      <Grid container spacing={2} sx={{
        maxHeight: 250, // Fixed height for the table
        overflowY: 'auto', // Enables vertical scrolling
      }}>
        {nonAvailableDrivers
          .filter((driver) => driver.driverUserRole === 'driver')
          .map((driver) => (
            <Grid
              item
              xs={12}
              container
              alignItems="center"
              spacing={2}
              key={driver.id}
            >
              {/* Driver Image */}
              <Grid item>
                {driver.driverImg ? (
                  <img
                    src={`${LARAVEL_API_URL}/${driver.driverImg}`}
                    alt="Driver"
                    style={{
                      width: "30px",  // Make image smaller
                      height: "30px", // Make image smaller
                      borderRadius: "50%",
                      marginRight: "8px",
                    }}
                  />
                ) : (
                  <Avatar
                    sx={{ width: 30, height: 30 }}  // Make avatar smaller
                    alt={`${driver.driverFirstName} ${driver.driverLastName}`}
                  />
                )}
              </Grid>

              {/* Driver Name */}
              <Grid item>
                <Typography variant="subtitle2" sx={{ fontSize: '0.875rem' }}>
                  {driver.driverFirstName} {driver.driverLastName}
                </Typography>
              </Grid>

              {/* Assign Button */}
               <Grid item sx={{ ml: 'auto' }}> 


               {selectedDrivers.find((d) => d.id === driver.id) && (
  <>
    <TextField
      size="small"
      label="Price"
      type="number"
      InputProps={{
        inputProps: { min: 0 }, 
      }}
      value={selectedDrivers.find((d) => d.id === driver.id)?.price || ""}
      onChange={(e) => handleInputChange(driver.id, "price", Number(e.target.value))}
      sx={{ ml: 2, width: 100 }}
    />
    <TextField
      size="small"
      label="Hour Price"
      type="number"
      InputProps={{
        inputProps: { min: 0 }, 
      }}
      value={selectedDrivers.find((d) => d.id === driver.id)?.hourPrice || ""}
      onChange={(e) => handleInputChange(driver.id, "hourPrice", Number(e.target.value))}
      sx={{ ml: 2, width: 100 }}
    />
  </>
)}

               <Checkbox
  size="small"
  checked={selectedDrivers.some((d) => d.id === driver.id)} 
  onChange={() => handleSelectDriver(driver.id)}
  disabled={
    selectedDrivers.length >= (invoiceList?.quoteWorkOrderSale?.[0]?.busCount || 0) &&
    !selectedDrivers.some((d) => d.id === driver.id) 
  }
/>

                {/* <Button
                  size="small"  // Small button size
                  variant="contained"
                  className={classes.addButton}
                  sx={{
                    fontSize: '0.65rem', // Smaller font size
                    padding: '4px 8px',  // Reduced padding for a smaller button
                    minWidth: 'auto',    // Allows the button width to shrink to fit content
                    textTransform: 'none', // Keeps the text case as-is
                  }}
                  onClick={() => handleAssignDriver(driver.id)}
                >
                  Assign
                </Button> */}
              </Grid> 
            </Grid>
          ))}


      </Grid>

      </>
          )}

      {/* Show More Button */}
    

        </CardContent>
      </Card>
    ) : (
      <Typography
    variant="body2"
    sx={{
      textAlign: 'center',
      width: '100%',
      mt: 2, // Top margin
      mb: 2, // Bottom margin
  
    }}
  >
    No drivers available
  </Typography>
    )}
  </Grid>



        {/* Right Side: Select Driver Section */}



        <Grid item lg={6} md={6} sm={12} xs={12}>
        <Typography variant="subtitle1">Bus Details</Typography>
          {
            invoiceList?.quoteWorkOrderSale.map((product: any, index: any) => (
              <Grid item lg={12} md={12} sm={12} xs={12} key={`${invoiceList?.id}-${index}`}>
                <Card className={classes.card} elevation={3}>
                  <CardContent>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                      {product.productName}
                    </Typography>
                    <Typography variant="subtitle1" component="div" gutterBottom>
                      {product.transferType
                        ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find(
                            (key) => TransferType[key] === String(product.transferType)
                          )
                        : ""}
                      {product.transferTypeFrom && product.transferTypeTo
                        ? ` (${product.transferTypeFrom} to ${product.transferTypeTo})`
                        : ""}
                    </Typography>
                    {product.departureAddress && product.departureDateTime && (
                      <Typography variant="body2" component="div" gutterBottom>
                        <>
                          <strong>Departure:</strong> {product.departureAddress}
                          <br />
                          ({dayjs(product.departureDateTime).isValid()
                            ? dayjs(product.departureDateTime).format("DD-MMM-YY hh:mm A")
                            : product.departureDateTime})
                        </>
                      </Typography>
                    )}
                    {product.destinationAddress && product.returnDateTime && (
                      <Typography variant="body2" component="div" gutterBottom>
                        <>
                          <strong>Destination:</strong> {product.destinationAddress}
                          <br />
                          ({dayjs(product.returnDateTime).isValid()
                            ? dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")
                            : product.returnDateTime})
                        </>
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))
    }
        </Grid>



      
      </Grid>
    </DialogContent>
    <DialogActions>
      <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
        <Card className={classes.card}>
          <Grid container spacing={3} p={"24px"}>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button disabled={loading} className={classes.addButton} onClick={handleAssignDriver} variant="contained">
                {loading ? <CircularProgress size={24} /> : "Assign"}
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </DialogActions>
  </Dialog>


<Dialog
  open={showPaymentDialog}
  onClose={handlePaymentDialogClose}
  PaperProps={{
    className: classes.BgDialog, // Apply the class here
  }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    Make a payment
    <IconButton
      aria-label="close"
      onClick={handlePaymentDialogClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CancelOutlined className={classes.CancelOutlined} />
    </IconButton>
  </DialogTitle>
  <DialogContent>
    <Grid container spacing={1} p={"14px"}>
 
      <Grid item lg={6} md={6} sm={6} xs={6}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">Date</Typography>
          </Grid>
           <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        size="small"
        type="date"
        value={paymentData.paymentDate}
        onChange={(e) => setPaymentData({ ...paymentData, paymentDate: e.target.value })}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>
        </Grid>
      </Grid>

        <Grid item lg={6} md={6} sm={6} xs={6}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">Amount</Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              type="number"
              className={classes.textField}
              InputProps={{
                sx: {
                  fontSize: 14,
                },
                inputProps: { min: 0 }
              }}
              InputLabelProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              value={paymentData.amount || editableAmount}
              onChange={(e) => setPaymentData({ ...paymentData, amount: e.target.value })}
            />
          </Grid>
        </Grid>
      </Grid>


      {/* Payment Method */}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">Select Payment Method</Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              select
              className={classes.textField}
              value={paymentData.paymentMethod} // Controlled by state
              onChange={(event) => {
    setPaymentData({ ...paymentData, paymentMethod: event.target.value });
    setShowPaymentMethodError(false);
  }}
   error={showPaymentMethodError}
  helperText={showPaymentMethodError ? "Payment method is required" : ""}
            >
              <MenuItem value="">Select option</MenuItem>
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Credit">Credit</MenuItem>
              <MenuItem value="Debit">Debit</MenuItem>
              <MenuItem value="E-Transfer">E-Transfer</MenuItem>
              <MenuItem value="Online banking">Online banking</MenuItem>
              <MenuItem value="Pre authorization">Pre authorization</MenuItem>
              <MenuItem value="Bank deposit">Bank deposit</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </Grid>

      {/* Description Field */}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">Description</Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              rows={4}
              className={classes.textField}
              multiline
              value={paymentData.description}
              onChange={(e) => setPaymentData({ ...paymentData, description: e.target.value })}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* File Upload */}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="subtitle1">Upload File</Typography>
            <Button variant="outlined" component="label">
              Upload File
              <input
                type="file"
                onChange={(e) => {
                  // Safely handle the case where files might be null
                  const file = e.target.files ? e.target.files[0] : null;
                  setPaymentData({ ...paymentData, file }); // Update the state with the file
                }}
                  style={{ display: "none" }}
                  id="file-upload"
              />
              
            </Button>

            {paymentData.file && (
    <Box sx={{ marginTop: 2 }}>
      <Typography variant="body2" >
        Selected File:  {paymentData.file.name}
      </Typography>
    </Box>
  )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </DialogContent>
  <DialogActions>
    <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
      <Card className={classes.card}>
        <Grid container spacing={3} p={"24px"}>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              disabled={loading}  
              className={classes.addButton}
              onClick={handleSavePayment}
              variant="contained"
            >
              {loading ? <CircularProgress size={24} /> : "Pay"}
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  </DialogActions>
</Dialog>




      
   <Grid item lg={12} md={12} sm={12} xs={12}>
  <Card className={classes.stepperCard}>
    {Array.isArray(emailLog) && emailLog.length > 0 && (
      emailLog
        .filter((email) => email.workOrderNo === WorkOrderDataList?.quoteWorkOrderNo &&
        email.amount !== null) // Ensures amount is not null)
        .map((email, index) => {

            const paymentTransaction = bamboraTransactionData.find(
              (transaction) => Number(transaction.trnAmount) === Number(email.amount)
          );
          return(

          <Grid
            container
            spacing={2}
            sx={{
              borderBottom: index !== emailLog.length - 1 ? '1px solid #e0e0e0' : 'none',
              padding: 2,
            }}

            key={index}
          >
            {/* Header Section */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                Date: {moment(`${email.created_at}`).format("MMM DD, YYYY, hh:mm a")}
                {email.subject && (
    <span
      style={{
        backgroundColor: '#2196F3',
        color: '#fff',
        borderRadius: '12px',
        padding: '2px 8px',
        marginLeft: '8px',
        fontSize: '0.7rem',
        fontWeight: '500',
        cursor: 'pointer',
      }}
    //  onClick={() => handleInvoiceClick(row.invoiceId)}
    >
   Email
    </span>
  )}
       
              </Typography>
             
            </Grid>


            {/* Payment Link Section */}
            <Grid item xs={8}>
              <Typography variant="body1" color="textSecondary">
              {Number(Number(WorkOrderDataList?.quoteWorkOrderSaleGrandTotal).toFixed(2)) === Number(email.amount) 
      ? 'Generate Payment Link (100%)' 
      : 'Generate Payment Link'}
        
              </Typography>
            </Grid>
            <Grid item xs={4} textAlign="right">
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {/* ${((Number(email.quoteWorkOrderSaleGrandTotal || 0) * 0.3) || 0).toFixed(2)} */}
                ${email.amount}
              </Typography>
            </Grid>

            {paymentTransaction ? (
  <Grid item xs={12}>
    <Card sx={{ padding: 3, borderRadius: 2, boxShadow: 'none', backgroundColor: '#f9fafb',  }}>
      {/* Payment Status Section */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 'bold',
          color: paymentTransaction.trnApproved === '1' ? '#4caf50' : '#f44336',
          display: 'flex',
          alignItems: 'center',
          marginBottom: 1,
        }}
      >
        {/* Icon based on status */}
        {paymentTransaction.trnApproved === '1' ? (
          <CheckCircleIcon sx={{ marginRight: 1, color: '#4caf50' }} />
        ) : (
          <CancelIcon sx={{ marginRight: 1, color: '#f44336' }} />
        )}
     {paymentTransaction.trnApproved === '1' ? 'Approved' : 'Declined'}
      </Typography>

      {/* Transaction Date and Time */}
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ marginTop: 1, display: 'inline-block', fontSize: '0.875rem' }}
      >
        {/* <strong>Date:</strong> {moment(paymentTransaction.trnDate).format('MMM DD, YYYY')} at {moment(paymentTransaction.trnTime, 'HH:mm:ss').format('hh:mm A')} */}
        <strong>Date:</strong> {moment(paymentTransaction.created_at).format('MMM DD, YYYY  hh:mm A')}

      </Typography>

      {/* Transaction ID and Card Type */}
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ marginTop: 1, fontSize: '0.875rem' }}
      >
        <strong>Transaction ID:</strong> {paymentTransaction.trnId}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ marginTop: 1, fontSize: '0.875rem' }}
      >
        <strong>Card Type:</strong> {paymentTransaction.trnCardType}
      </Typography>
    </Card>
  </Grid>
) : (
  <Grid item xs={12}>
    <Card sx={{ padding: 3, borderRadius: 2, boxShadow: 'none', backgroundColor: '#f9fafb' }}>
      <Typography variant="body2" sx={{ textAlign: 'center', color: '#9e9e9e' }}>
        No Transaction made yet
      </Typography>
    </Card>
  </Grid>
)}


            <Grid item xs={8}>
            <Button
    sx={{
      fontSize: '0.75rem',
      padding: '4px 0px',
      minWidth: 'auto',
      textTransform: 'none',
    }}
    onClick={() => toggleStepDetail(index)}
  >
    {expandedStep.includes(index) ? 'Show less' : 'Show more'}
  </Button>
  </Grid> 
  <Grid item xs={12}>
  {expandedStep.includes(index) && (
      <div>
            
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                Subject:
              </Typography>
              <Typography variant="body2" sx={{ marginBottom: 2 }}>
                {email.subject || 'No subject available'}
              </Typography>

              {/* Message Section */}
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                Message:
              </Typography>
              <Typography
  variant="body2"
  sx={{
    whiteSpace: 'pre-line', // This ensures that new lines are preserved
    lineHeight: 0.9, // Better line spacing for readability
    wordBreak: 'break-word', // Avoids word overflow issues
  }}
  dangerouslySetInnerHTML={{ __html: email.message || 'No message available' }} // Render the HTML safely
/>
</div>
 )}
</Grid>
            {/* Action Buttons */}
            <Grid item xs={12} textAlign="right" >
              <Button
                variant="contained"
                color="primary"
                className={classes.addButton}
                onClick={handleReSendPaymentLink}
                sx={{ marginRight: 2, 
                  fontSize: '0.75rem', // Smaller font size
                  padding: '4px 8px',  // Reduced padding for a smaller button
                  minWidth: 'auto',    // Allows the button width to shrink to fit content
                  textTransform: 'none', // Keeps the text case as-is
                }}
              >
                Resend by Email
              </Button>
              <Button
                variant="contained"
               // color="secondary"
                className={classes.addButton}
                sx={{
                  fontSize: '0.75rem', // Smaller font size
                  padding: '4px 8px',  // Reduced padding for a smaller button
                  minWidth: 'auto',    // Allows the button width to shrink to fit content
                  textTransform: 'none', // Keeps the text case as-is
                }}
              >
                Resend by Text
              </Button>
            </Grid>
          </Grid>
           );
      })
    )}
  </Card>
</Grid>

    
   
{payments.length > 0 && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" fontWeight="bold">
              Payment History
            </Typography>
          </Grid>

          {payments.map((payment) => (
            <Grid item xs={12} key={payment.id}>
              <Card className={classes.stepperCard}    
              sx={{ padding: 2, borderRadius: 2 , backgroundColor: (theme) => `${alpha(theme.palette.primary.light, 0.1)} !important`,   position: 'relative' }}>
                <Box display="flex" flexDirection="column" gap={1}>
 <Box display="flex" justifyContent="space-between" alignItems="center">

        <Typography variant="body2" color="textSecondary">
                    {/* {dayjs(payment.created_at).format("MMM D, YYYY h:mm A")} */}
                    {moment(payment.payment_date).format('MMM DD, YYYY')}
                  </Typography>
 {payment.payment_mode.toLowerCase() === 'online' ? (
            <IconButton
            
              color="warning"
              title="Refund"
              onClick={(e) => refundPayment(payment.transaction_id)}
              size="small"
              sx={{ p: 0 ,
                 color: (theme) => theme.palette.warning.dark,
    //               backgroundColor: (theme) => theme.palette.warning.light,
    //                  padding: "6px",
    // borderRadius: "6px",
    // '&:hover': {
    //   backgroundColor: (theme) => theme.palette.warning.main, // darker on hover
    // },
              }}
            >
            {isRefundLoading ? (
    <CircularProgress size={18} color="inherit" />
  ) : (
    // <ReplayIcon fontSize="small" />
     <FaUndo style={{ fontSize: 16 }} />
  )}
            </IconButton>
          ) : (
            <IconButton
              color="error"
              title="Delete"
              onClick={(e) => deletePayment(payment.id)}
              size="small"
              sx={{ p: 0 
                
              }}
            >
              <FaTrash style={{ fontSize: 16 }} />
               {/* {isDeleteLoading ? (
    <CircularProgress size={18} color="inherit" />
  ) : (
    <FaTrash style={{ fontSize: 16 }} />
  )} */}
            </IconButton>
          )}
            </Box>
                   
          
      
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    ${payment.amount}
                  </Typography>

                  {/* Payment Method */}
                  <Box display="flex" alignItems="center">
                    <Typography variant="body1">
                      <strong>Method:</strong> {payment.payment_method}
                    </Typography>

                    {/* File Button */}
                    {payment.file_path && (
                      <Button
                        variant="text"
                        size="small"
                        onClick={() => payment.file_path && handleOpenModal(payment.file_path)}
                        sx={{ minWidth: "auto", padding: 0, marginLeft: 1 }}
                      >
                        <DescriptionIcon color="primary" fontSize="small" />
                      </Button>
                    )}
                  </Box>

                  {/* Payment Mode */}
                  <Box
                    sx={{
                      display: "inline-block",
                      backgroundColor:
                      payment.payment_mode === "ONLINE" ? "#C2E5B3" : "#F8D7DA",
                      color: payment.payment_mode === "ONLINE" ? "#2E7D32" : "#D32F2F",
                      padding: "4px 10px",
                      borderRadius: 2,
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      textTransform: "capitalize",
                      width: "fit-content"
                    }}
                  >
                    {payment.payment_mode.toLowerCase()}
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
        </Grid>
      )}


      {refunds.length > 0 && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" fontWeight="bold">
              Refund History
            </Typography>
          </Grid>

          {refunds.map((payment) => (
            <Grid item xs={12} key={payment.id}>
              <Card className={classes.stepperCard}    
              sx={{ padding: 2, borderRadius: 2 , backgroundColor: (theme) => `${alpha(theme.palette.primary.light, 0.1)} !important`,   position: 'relative' }}>
                <Box display="flex" flexDirection="column" gap={1}>
 <Box display="flex" justifyContent="space-between" alignItems="center">

        <Typography variant="body2" color="textSecondary">
                    {dayjs(payment.updated_at).format("MMM D, YYYY h:mm A")}
                  </Typography>

            </Box>
                   
          
      
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    ${payment.amount}
                  </Typography>

                  {/* Payment Method */}
                  <Box display="flex" alignItems="center">
                    <Typography variant="body1">
                      <strong>Method:</strong> {payment.payment_method}
                    </Typography>

                 
                  
                   {/* <Typography variant="body2" color="textSecondary">
                    {dayjs(payment.created_at).format("MMM D, YYYY h:mm A")}
                  </Typography> */}
                    {/* {payment.file_path && (
                      <Button
                        variant="text"
                        size="small"
                        onClick={() => payment.file_path && handleOpenModal(payment.file_path)}
                        sx={{ minWidth: "auto", padding: 0, marginLeft: 1 }}
                      >
                        <DescriptionIcon color="primary" fontSize="small" />
                      </Button>
                    )} */}
                  </Box>

                  {/* Payment Mode */}
                  <Box
                    sx={{
                      display: "inline-block",
                      backgroundColor:
                      payment.payment_mode === "ONLINE" ? "#C2E5B3" : "#F8D7DA",
                      color: payment.payment_mode === "ONLINE" ? "#2E7D32" : "#D32F2F",
                      padding: "4px 10px",
                      borderRadius: 2,
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      textTransform: "capitalize",
                      width: "fit-content"
                    }}
                  >
                    {payment.payment_mode.toLowerCase()}
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
        </Grid>
      )}

      {/* Modal Dialog */}
      <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="md">
        <DialogTitle>View File</DialogTitle>
        <DialogContent>
          {isPdf ? (
            <iframe
              src={fileUrl || ""}
              style={{ width: "100%", height: "500px" }}
              title="PDF Viewer"
            />
          ) : (
            <img
              src={fileUrl || ""}
              alt="File Content"
              style={{
                width: "100%",
                height: "500px",
                objectFit: "contain"
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
   



    {/* Order Timeline */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.stepperCard}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>
                  Order Timeline
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
                className={classes.titleGrid}
              >
                <Box>
                  {workOrderHistoryIsLoading ? (
                    <CircularProgress />
                  ) : workOrderHistoryError ? (
                    <Typography color="error">
                      Error fetching quote history
                    </Typography>
                  ) : (
                    <>
                      <Stepper
                        orientation="vertical"
                        activeStep={timeLineSteps.length}
                      >
                        {timeLineSteps
                          .slice()
                          // .reverse() 
                          .map((step, index) => (
                            <Step key={step.label} completed>
                              <StepLabel>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Typography className={classes.h5}>
                                    {step.label}
                                  </Typography>
                                  <Button
                                    variant="contained"
                                    className={classes.editButtonList}
                                    onClick={() => toggleStepDetails(index)}
                                  >
                                    {expandedSteps.includes(index) ? (
                                      <ExpandLessSharpIcon
                                        className={classes.editListIcon}
                                      />
                                    ) : (
                                      <ExpandMoreSharpIcon
                                        className={classes.editListIcon}
                                      />
                                    )}
                                  </Button>
                                </Box>
                              </StepLabel>

                              {expandedSteps.includes(index) && (
                                <Box sx={{ ml: 4, mt: 1 }}>
                                  <Typography>{step.description}</Typography>
                                </Box>
                              )}
                            </Step>
                          ))}

                        {/* Last step + 1 with loading spinner */}
                        <Step>
                          <StepLabel>
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Typography>Next...</Typography>
                              <Button
                                variant="contained"
                                className={classes.editButtonList}
                              >
                                <CircularProgress size={24} />
                              </Button>
                            </Box>
                          </StepLabel>
                        </Step>
                      </Stepper>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
</Grid>


            <Dialog open={open} onClose={handleCloseDialog}>
              <Grid className={classes.Dialog}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Confirm Action
                    </Typography>
                  </Grid>
                </Grid>
                <DialogContent>
                  <DialogContentText sx={{ pt: 3 }}>
                    Are you sure you want to proceed with invoice success?
            
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{mt:2}}>
                    <TextField
            label="Enter PO Number"
            variant="outlined"
            size="small"
            className={classes.textField}
            value={poNumber}
            onChange={(e) => setPoNumber(e.target.value)}
          />
          </Grid>
  
                  </DialogContentText>
                </DialogContent>
                <DialogActions
                  sx={{ paddingRight: "24px", p: 4, py: 3, gap: 2 }}
                >
                  <Grid container spacing={3}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<CloseIcon />}
                        className={classes.addButton}
                        onClick={handleCloseDialog}
                      >
                        Cancel
                      </Button>
                      <Box m={0.5}></Box>

                      <Button
                        variant="contained"
                        startIcon={<CheckCircleOutlineSharpIcon />}
                        className={classes.addButton}
                        onClick={handleConfirmDialog}
                      >
                        Yes
                      </Button>
                    </Grid>
                  </Grid>
                </DialogActions>
              </Grid>
            </Dialog>



            <Dialog
  open={isPoNumberDialogOpen}
  onClose={handleClosePoNumberDialog}
  PaperProps={{
    className: classes.BgDialog, // Apply the class here
  }}
  maxWidth="sm"
  fullWidth
>
<DialogTitle>
Add Po number
    <IconButton
      aria-label="close"
      onClick={handleClosePoNumberDialog}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CancelOutlined className={classes.CancelOutlined} />
    </IconButton>
  </DialogTitle>
  <DialogContent>


  <Grid container spacing={1} p={"14px"}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography variant="subtitle1">PO Number</Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              className={classes.textField}
              InputProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: 14,
                },
              }}
            value={poNumber}
            onChange={(e) => setPoNumber(e.target.value)} 
            />
          </Grid>
        </Grid>
      </Grid>
  
</Grid>
  </DialogContent>
  <DialogActions>
    <DialogActions>
    <Grid item lg={12} md={12} sm={12} xs={12} >
     
        <Grid container p={"24px"}>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
  disabled={loading}
  className={classes.addButton}
  onClick={() => updateInvoicePoNumber(poNumber)} 
  variant="contained"
>
  {loading ? <CircularProgress size={24} /> : "Save"}
</Button>

          </Grid>
        </Grid>
     
    </Grid>
  </DialogActions>

  </DialogActions>
</Dialog>



{openViewQuote && (
<Dialog open={openViewQuote} onClose={handleCloseViewQuote} maxWidth="md" fullWidth
  fullScreen={isMobile} 
>
<DialogTitle><Typography variant="h5" component="div">
Quote Details
</Typography></DialogTitle>
<DialogContent >
<ViewWorkOrder  quoteId={workOrderId} type="view" /> 
</DialogContent>
<DialogActions>
 <Button onClick={handleCloseViewQuote}>Close</Button>
</DialogActions>
</Dialog>
)}


  {openViewInvoice && (
                      
   <Dialog open={openViewInvoice} onClose={handleCloseViewInvoice} maxWidth="md" fullWidth
   >
     <DialogTitle><Typography variant="h5" component="div">
     Invoice Details
   </Typography></DialogTitle>
     <DialogContent >
    
     <ViewInvoice invoiceId={invoiceId} type="view" />
    
     </DialogContent>
     <DialogActions>
       <Button onClick={handleCloseViewInvoice}>Close</Button>
     </DialogActions>
   </Dialog>
 
 
 )}


          </Grid>
        </>
      )}
    </div>
  );
};
export default Index;
